/*!
 * modernizr v3.5.0
 * Build https://modernizr.com/download?-adownload-animation-appearance-applicationcache-backgroundblendmode-backgroundcliptext-bdi-blobconstructor-blobworkers-borderimage-contenteditable-contextmenu-cookies-cors-cssall-cssfilters-cssmask-csspointerevents-cssreflections-cssresize-cssvmaxunit-customevent-dataview-dataworkers-details-documentfragment-es6array-es6collections-es6math-es6number-es6object-es6string-eventlistener-filereader-filesystem-flash-flexboxtweener-flexwrap-forcetouch-formvalidation-fullscreen-generators-geolocation-getrandomvalues-hashchange-hiddenscroll-history-htmlimports-indexeddb-indexeddbblob-input-inputtypes-intl-ligatures-objectfit-olreversed-outputelem-pagevisibility-performance-picture-placeholder-pointerevents-pointerlock-postmessage-preserve3d-promises-proximity-queryselector-quotamanagement-requestanimationframe-search-serviceworker-shapes-sharedworkers-supports-svg-svgclippaths-template-templatestrings-textalignlast-texttrackapi_track-touchevents-transferables-typedarrays-unknownelements-webaudio-webgl-webp-websockets-websocketsbinary-willchange-addtest-atrule-domprefixes-hasevent-mq-prefixed-prefixedcss-prefixedcssvalue-prefixes-setclasses-testallprops-testprop-teststyles-dontmin
 *
 * Copyright (c)
 *  Faruk Ates
 *  Paul Irish
 *  Alex Sexton
 *  Ryan Seddon
 *  Patrick Kettner
 *  Stu Cox
 *  Richard Herrera

 * MIT License
 */

/*
 * Modernizr tests which native CSS3 and HTML5 features are available in the
 * current UA and makes the results available to you in two ways: as properties on
 * a global `Modernizr` object, and as classes on the `<html>` element. This
 * information allows you to progressively enhance your pages with a granular level
 * of control over the experience.
*/

; (function (window, document, undefined) {
    var classes = [];


    var tests = [];


    /**
     *
     * ModernizrProto is the constructor for Modernizr
     *
     * @class
     * @access public
     */

    var ModernizrProto = {
        // The current version, dummy
        _version: '3.5.0',

        // Any settings that don't work as separate modules
        // can go in here as configuration.
        _config: {
            'classPrefix': '',
            'enableClasses': true,
            'enableJSClass': true,
            'usePrefixes': true
        },

        // Queue of tests
        _q: [],

        // Stub these for people who are listening
        on: function (test, cb) {
            // I don't really think people should do this, but we can
            // safe guard it a bit.
            // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
            // This is in case people listen to synchronous tests. I would leave it out,
            // but the code to *disallow* sync tests in the real version of this
            // function is actually larger than this.
            var self = this;
            setTimeout(function () {
                cb(self[test]);
            }, 0);
        },

        addTest: function (name, fn, options) {
            tests.push({ name: name, fn: fn, options: options });
        },

        addAsyncTest: function (fn) {
            tests.push({ name: null, fn: fn });
        }
    };



    // Fake some of Object.create so we can force non test results to be non "own" properties.
    var Modernizr = function () { };
    Modernizr.prototype = ModernizrProto;

    // Leak modernizr globally when you `require` it rather than force it here.
    // Overwrite name so constructor name is nicer :D
    Modernizr = new Modernizr();


    /*!
    {
      "name": "Application Cache",
      "property": "applicationcache",
      "caniuse": "offline-apps",
      "tags": ["storage", "offline"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en/docs/HTML/Using_the_application_cache"
      }],
      "polyfills": ["html5gears"]
    }
    !*/
    /* DOC
    Detects support for the Application Cache, for storing data to enable web-based applications run offline.
    
    The API has been [heavily criticized](http://alistapart.com/article/application-cache-is-a-douchebag) and discussions are underway to address this.
    */

    Modernizr.addTest('applicationcache', 'applicationCache' in window);

    /*!
    {
      "name": "Blob constructor",
      "property": "blobconstructor",
      "aliases": ["blob-constructor"],
      "builderAliases": ["blob_constructor"],
      "caniuse": "blobbuilder",
      "notes": [{
        "name": "W3C spec",
        "href": "https://w3c.github.io/FileAPI/#constructorBlob"
      }],
      "polyfills": ["blobjs"]
    }
    !*/
    /* DOC
    Detects support for the Blob constructor, for creating file-like objects of immutable, raw data.
    */

    Modernizr.addTest('blobconstructor', function () {
        try {
            return !!new Blob();
        } catch (e) {
            return false;
        }
    }, {
        aliases: ['blob-constructor']
    });

    /*!
    {
      "name": "Cookies",
      "property": "cookies",
      "tags": ["storage"],
      "authors": ["tauren"]
    }
    !*/
    /* DOC
    Detects whether cookie support is enabled.
    */

    // https://github.com/Modernizr/Modernizr/issues/191

    Modernizr.addTest('cookies', function () {
        // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking
        // configurations. For example, when blocking cookies via the Advanced
        // Privacy Settings in IE9, it always returns true. And there have been
        // issues in the past with site-specific exceptions.
        // Don't rely on it.

        // try..catch because some in situations `document.cookie` is exposed but throws a
        // SecurityError if you try to access it; e.g. documents created from data URIs
        // or in sandboxed iframes (depending on flags/context)
        try {
            // Create cookie
            document.cookie = 'cookietest=1';
            var ret = document.cookie.indexOf('cookietest=') != -1;
            // Delete cookie
            document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
            return ret;
        }
        catch (e) {
            return false;
        }
    });

    /*!
    {
      "name": "Cross-Origin Resource Sharing",
      "property": "cors",
      "caniuse": "cors",
      "authors": ["Theodoor van Donge"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/HTTP/Access_control_CORS"
      }],
      "polyfills": ["pmxdr", "ppx", "flxhr"]
    }
    !*/
    /* DOC
    Detects support for Cross-Origin Resource Sharing: method of performing XMLHttpRequests across domains.
    */

    Modernizr.addTest('cors', 'XMLHttpRequest' in window && 'withCredentials' in new XMLHttpRequest());

    /*!
    {
      "name": "CustomEvent",
      "property": "customevent",
      "tags": ["customevent"],
      "authors": ["Alberto Elias"],
      "notes": [{
        "name": "W3C DOM reference",
        "href": "https://www.w3.org/TR/DOM-Level-3-Events/#interface-CustomEvent"
      }, {
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en/docs/Web/API/CustomEvent"
      }],
      "polyfills": ["eventlistener"]
    }
    !*/
    /* DOC
    
    Detects support for CustomEvent.
    
    */

    Modernizr.addTest('customevent', 'CustomEvent' in window && typeof window.CustomEvent === 'function');

    /*!
    {
      "name": "DataView",
      "property": "dataview",
      "authors": ["Addy Osmani"],
      "builderAliases": ["dataview_api"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en/JavaScript_typed_arrays/DataView"
      }],
      "polyfills": ["jdataview"]
    }
    !*/
    /* DOC
    Detects support for the DataView interface for reading data from an ArrayBuffer as part of the Typed Array spec.
    */

    Modernizr.addTest('dataview', (typeof DataView !== 'undefined' && 'getFloat64' in DataView.prototype));

    /*!
    {
      "name": "Event Listener",
      "property": "eventlistener",
      "authors": ["Andrew Betts (@triblondon)"],
      "notes": [{
        "name": "W3C Spec",
        "href": "https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-Registration-interfaces"
      }],
      "polyfills": ["eventlistener"]
    }
    !*/
    /* DOC
    Detects native support for addEventListener
    */

    Modernizr.addTest('eventlistener', 'addEventListener' in window);

    /*!
    {
      "name": "Geolocation API",
      "property": "geolocation",
      "caniuse": "geolocation",
      "tags": ["media"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/WebAPI/Using_geolocation"
      }],
      "polyfills": [
        "joshuabell-polyfill",
        "webshims",
        "geo-location-javascript",
        "geolocation-api-polyfill"
      ]
    }
    !*/
    /* DOC
    Detects support for the Geolocation API for users to provide their location to web applications.
    */

    // geolocation is often considered a trivial feature detect...
    // Turns out, it's quite tricky to get right:
    //
    // Using !!navigator.geolocation does two things we don't want. It:
    //   1. Leaks memory in IE9: github.com/Modernizr/Modernizr/issues/513
    //   2. Disables page caching in WebKit: webk.it/43956
    //
    // Meanwhile, in Firefox < 8, an about:config setting could expose
    // a false positive that would throw an exception: bugzil.la/688158

    Modernizr.addTest('geolocation', 'geolocation' in navigator);

    /*!
    {
      "name": "History API",
      "property": "history",
      "caniuse": "history",
      "tags": ["history"],
      "authors": ["Hay Kranen", "Alexander Farkas"],
      "notes": [{
        "name": "W3C Spec",
        "href": "https://www.w3.org/TR/html51/browsers.html#the-history-interface"
      }, {
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/window.history"
      }],
      "polyfills": ["historyjs", "html5historyapi"]
    }
    !*/
    /* DOC
    Detects support for the History API for manipulating the browser session history.
    */

    Modernizr.addTest('history', function () {
        // Issue #733
        // The stock browser on Android 2.2 & 2.3, and 4.0.x returns positive on history support
        // Unfortunately support is really buggy and there is no clean way to detect
        // these bugs, so we fall back to a user agent sniff :(
        var ua = navigator.userAgent;

        // We only want Android 2 and 4.0, stock browser, and not Chrome which identifies
        // itself as 'Mobile Safari' as well, nor Windows Phone (issue #1471).
        if ((ua.indexOf('Android 2.') !== -1 ||
            (ua.indexOf('Android 4.0') !== -1)) &&
            ua.indexOf('Mobile Safari') !== -1 &&
            ua.indexOf('Chrome') === -1 &&
            ua.indexOf('Windows Phone') === -1 &&
            // Since all documents on file:// share an origin, the History apis are
            // blocked there as well
            location.protocol !== 'file:'
        ) {
            return false;
        }

        // Return the regular check
        return (window.history && 'pushState' in window.history);
    });

    /*!
    {
      "name": "postMessage",
      "property": "postmessage",
      "caniuse": "x-doc-messaging",
      "notes": [{
        "name": "W3C Spec",
        "href": "http://www.w3.org/TR/html5/comms.html#posting-messages"
      }],
      "polyfills": ["easyxdm", "postmessage-jquery"]
    }
    !*/
    /* DOC
    Detects support for the `window.postMessage` protocol for cross-document messaging.
    */

    Modernizr.addTest('postmessage', 'postMessage' in window);

    /*!
    {
      "name": "QuerySelector",
      "property": "queryselector",
      "caniuse": "queryselector",
      "tags": ["queryselector"],
      "authors": ["Andrew Betts (@triblondon)"],
      "notes": [{
        "name" : "W3C Selectors reference",
        "href": "https://www.w3.org/TR/selectors-api/#queryselectorall"
      }],
      "polyfills": ["css-selector-engine"]
    }
    !*/
    /* DOC
    Detects support for querySelector.
    */

    Modernizr.addTest('queryselector', 'querySelector' in document && 'querySelectorAll' in document);

    /*!
    {
      "name": "ServiceWorker API",
      "property": "serviceworker",
      "notes": [{
        "name": "ServiceWorkers Explained",
        "href": "https://github.com/slightlyoff/ServiceWorker/blob/master/explainer.md"
      }]
    }
    !*/
    /* DOC
    ServiceWorkers (formerly Navigation Controllers) are a way to persistently cache resources to built apps that work better offline.
    */

    Modernizr.addTest('serviceworker', 'serviceWorker' in navigator);

    /*!
    {
      "name": "SVG",
      "property": "svg",
      "caniuse": "svg",
      "tags": ["svg"],
      "authors": ["Erik Dahlstrom"],
      "polyfills": [
        "svgweb",
        "raphael",
        "amplesdk",
        "canvg",
        "svg-boilerplate",
        "sie",
        "dojogfx",
        "fabricjs"
      ]
    }
    !*/
    /* DOC
    Detects support for SVG in `<embed>` or `<object>` elements.
    */

    Modernizr.addTest('svg', !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect);

    /*!
    {
      "name": "Template strings",
      "property": "templatestrings",
      "notes": [{
        "name": "MDN Reference",
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/template_strings#Browser_compatibility"
      }]
    }
    !*/
    /* DOC
    Template strings are string literals allowing embedded expressions.
    */

    Modernizr.addTest('templatestrings', function () {
        var supports;
        try {
            // A number of tools, including uglifyjs and require, break on a raw "`", so
            // use an eval to get around that.
            // eslint-disable-next-line
            eval('``');
            supports = true;
        } catch (e) { }
        return !!supports;
    });

    /*!
    {
      "name": "Typed arrays",
      "property": "typedarrays",
      "caniuse": "typedarrays",
      "tags": ["js"],
      "authors": ["Stanley Stuart (@fivetanley)"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/JavaScript_typed_arrays"
      },{
        "name": "Kronos spec",
        "href": "https://www.khronos.org/registry/typedarray/specs/latest/"
      }],
      "polyfills": ["joshuabell-polyfill"]
    }
    !*/
    /* DOC
    Detects support for native binary data manipulation via Typed Arrays in JavaScript.
    
    Does not check for DataView support; use `Modernizr.dataview` for that.
    */

    // Should fail in:
    // Internet Explorer <= 9
    // Firefox <= 3.6
    // Chrome <= 6.0
    // iOS Safari < 4.2
    // Safari < 5.1
    // Opera < 11.6
    // Opera Mini, <= 7.0
    // Android Browser < 4.0
    // Blackberry Browser < 10.0

    Modernizr.addTest('typedarrays', 'ArrayBuffer' in window);

    /*!
    {
      "name": "WebSockets Support",
      "property": "websockets",
      "authors": ["Phread [fearphage]", "Mike Sherov [mikesherov]", "Burak Yigit Kaya [BYK]"],
      "caniuse": "websockets",
      "tags": ["html5"],
      "warnings": [
        "This test will reject any old version of WebSockets even if it is not prefixed such as in Safari 5.1"
      ],
      "notes": [{
        "name": "CLOSING State and Spec",
        "href": "https://www.w3.org/TR/websockets/#the-websocket-interface"
      }],
      "polyfills": [
        "sockjs",
        "socketio",
        "kaazing-websocket-gateway",
        "websocketjs",
        "atmosphere",
        "graceful-websocket",
        "portal",
        "datachannel"
      ]
    }
    !*/

    var supports = false;
    try {
        supports = 'WebSocket' in window && window.WebSocket.CLOSING === 2;
    } catch (e) { }
    Modernizr.addTest('websockets', supports);

    /*!
    {
      "name": "Web Audio API",
      "property": "webaudio",
      "caniuse": "audio-api",
      "polyfills": ["xaudiojs", "dynamicaudiojs", "audiolibjs"],
      "tags": ["audio", "media"],
      "builderAliases": ["audio_webaudio_api"],
      "authors": ["Addy Osmani"],
      "notes": [{
        "name": "W3 Specification",
        "href": "https://dvcs.w3.org/hg/audio/raw-file/tip/webaudio/specification.html"
      }]
    }
    !*/
    /* DOC
    Detects the older non standard webaudio API, (as opposed to the standards based AudioContext API)
    */

    Modernizr.addTest('webaudio', function () {
        var prefixed = 'webkitAudioContext' in window;
        var unprefixed = 'AudioContext' in window;

        if (Modernizr._config.usePrefixes) {
            return prefixed || unprefixed;
        }
        return unprefixed;
    });

    /*!
    {
      "name": "CSS Supports",
      "property": "supports",
      "caniuse": "css-featurequeries",
      "tags": ["css"],
      "builderAliases": ["css_supports"],
      "notes": [{
        "name": "W3 Spec",
        "href": "http://dev.w3.org/csswg/css3-conditional/#at-supports"
      },{
        "name": "Related Github Issue",
        "href": "https://github.com/Modernizr/Modernizr/issues/648"
      },{
        "name": "W3 Info",
        "href": "http://dev.w3.org/csswg/css3-conditional/#the-csssupportsrule-interface"
      }]
    }
    !*/

    var newSyntax = 'CSS' in window && 'supports' in window.CSS;
    var oldSyntax = 'supportsCSS' in window;
    Modernizr.addTest('supports', newSyntax || oldSyntax);

    /*!
    {
      "name": "picture Element",
      "property": "picture",
      "tags": ["elem"],
      "authors": ["Scott Jehl", "Mat Marquis"],
      "notes": [{
        "name": "Specification",
        "href": "http://picture.responsiveimages.org"
      },{
        "name": "Relevant spec issue",
        "href": "https://github.com/ResponsiveImagesCG/picture-element/issues/87"
      }]
    }
    !*/

    Modernizr.addTest('picture', 'HTMLPictureElement' in window);

    /*!
    {
      "name": "ES6 Array",
      "property": "es6array",
      "notes": [{
        "name": "unofficial ECMAScript 6 draft specification",
        "href": "https://people.mozilla.org/~jorendorff/es6-draft.html"
      }],
      "polyfills": ["es6shim"],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "warnings": ["ECMAScript 6 is still a only a draft, so this detect may not match the final specification or implementations."],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Array per specification.
    */

    Modernizr.addTest('es6array', !!(Array.prototype &&
      Array.prototype.copyWithin &&
      Array.prototype.fill &&
      Array.prototype.find &&
      Array.prototype.findIndex &&
      Array.prototype.keys &&
      Array.prototype.entries &&
      Array.prototype.values &&
      Array.from &&
      Array.of));

    /*!
    {
      "name": "ES6 Collections",
      "property": "es6collections",
      "notes": [{
        "name": "unofficial ECMAScript 6 draft specification",
        "href": "https://people.mozilla.org/~jorendorff/es6-draft.html"
      }],
      "polyfills": ["es6shim", "weakmap"],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "warnings": ["ECMAScript 6 is still a only a draft, so this detect may not match the final specification or implementations."],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Map, Set, WeakMap and WeakSet
    */

    Modernizr.addTest('es6collections', !!(
      window.Map && window.Set && window.WeakMap && window.WeakSet
    ));

    /*!
    {
      "name": "ES6 Generators",
      "property": "generators",
      "authors": ["Michael Kachanovskyi"],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Generators per specification.
    */

    Modernizr.addTest('generators', function () {
        try {
            new Function('function* test() {}')();
        } catch (e) {
            return false;
        }
        return true;
    });

    /*!
    {
      "name": "ES6 Math",
      "property": "es6math",
      "notes": [{
        "name": "unofficial ECMAScript 6 draft specification",
        "href": "https://people.mozilla.org/~jorendorff/es6-draft.html"
      }],
      "polyfills": ["es6shim"],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "warnings": ["ECMAScript 6 is still a only a draft, so this detect may not match the final specification or implementations."],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Math per specification.
    */

    Modernizr.addTest('es6math', !!(Math &&
      Math.clz32 &&
      Math.cbrt &&
      Math.imul &&
      Math.sign &&
      Math.log10 &&
      Math.log2 &&
      Math.log1p &&
      Math.expm1 &&
      Math.cosh &&
      Math.sinh &&
      Math.tanh &&
      Math.acosh &&
      Math.asinh &&
      Math.atanh &&
      Math.hypot &&
      Math.trunc &&
      Math.fround));

    /*!
    {
      "name": "ES6 Number",
      "property": "es6number",
      "notes": [{
        "name": "unofficial ECMAScript 6 draft specification",
        "href": "https://people.mozilla.org/~jorendorff/es6-draft.html"
      }],
      "polyfills": ["es6shim"],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "warnings": ["ECMAScript 6 is still a only a draft, so this detect may not match the final specification or implementations."],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Number per specification.
    */

    Modernizr.addTest('es6number', !!(Number.isFinite &&
      Number.isInteger &&
      Number.isSafeInteger &&
      Number.isNaN &&
      Number.parseInt &&
      Number.parseFloat &&
      Number.isInteger(Number.MAX_SAFE_INTEGER) &&
      Number.isInteger(Number.MIN_SAFE_INTEGER) &&
      Number.isFinite(Number.EPSILON)));

    /*!
    {
      "name": "ES6 Object",
      "property": "es6object",
      "notes": [{
        "name": "unofficial ECMAScript 6 draft specification",
        "href": "https://people.mozilla.org/~jorendorff/es6-draft.html"
      }],
      "polyfills": ["es6shim"],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "warnings": ["ECMAScript 6 is still a only a draft, so this detect may not match the final specification or implementations."],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Object per specification.
    */

    Modernizr.addTest('es6object', !!(Object.assign &&
      Object.is &&
      Object.setPrototypeOf));

    /*!
    {
      "name": "ES6 Promises",
      "property": "promises",
      "caniuse": "promises",
      "polyfills": ["es6promises"],
      "authors": ["Krister Kari", "Jake Archibald"],
      "tags": ["es6"],
      "notes": [{
        "name": "The ES6 promises spec",
        "href": "https://github.com/domenic/promises-unwrapping"
      },{
        "name": "Chromium dashboard - ES6 Promises",
        "href": "https://www.chromestatus.com/features/5681726336532480"
      },{
        "name": "JavaScript Promises: There and back again - HTML5 Rocks",
        "href": "http://www.html5rocks.com/en/tutorials/es6/promises/"
      }]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 Promises per specification.
    */

    Modernizr.addTest('promises', function () {
        return 'Promise' in window &&
        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        'resolve' in window.Promise &&
        'reject' in window.Promise &&
        'all' in window.Promise &&
        'race' in window.Promise &&
        // Older version of the spec had a resolver object
        // as the arg rather than a function
        (function () {
            var resolve;
            new window.Promise(function (r) { resolve = r; });
            return typeof resolve === 'function';
        }());
    });

    /*!
    {
      "name": "ES6 String",
      "property": "es6string",
      "notes": [{
        "name": "unofficial ECMAScript 6 draft specification",
        "href": "https://people.mozilla.org/~jorendorff/es6-draft.html"
      }],
      "polyfills": ["es6shim"],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "warnings": ["ECMAScript 6 is still a only a draft, so this detect may not match the final specification or implementations."],
      "tags": ["es6"]
    }
    !*/
    /* DOC
    Check if browser implements ECMAScript 6 String per specification.
    */

    Modernizr.addTest('es6string', !!(String.fromCodePoint &&
      String.raw &&
      String.prototype.codePointAt &&
      String.prototype.repeat &&
      String.prototype.startsWith &&
      String.prototype.endsWith &&
      String.prototype.includes));

    /*!
    {
      "name": "File API",
      "property": "filereader",
      "caniuse": "fileapi",
      "notes": [{
        "name": "W3C Working Draft",
        "href": "https://www.w3.org/TR/FileAPI/"
      }],
      "tags": ["file"],
      "builderAliases": ["file_api"],
      "knownBugs": ["Will fail in Safari 5 due to its lack of support for the standards defined FileReader object"]
    }
    !*/
    /* DOC
    `filereader` tests for the File API specification
    
    Tests for objects specific to the File API W3C specification without
    being redundant (don't bother testing for Blob since it is assumed
    to be the File object's prototype.)
    */

    Modernizr.addTest('filereader', !!(window.File && window.FileList && window.FileReader));

    /*!
    {
      "name": "Binary WebSockets",
      "property": "websocketsbinary",
      "tags": ["websockets"],
      "builderAliases": ["websockets_binary"]
    }
    !*/

    // binaryType is truthy if there is support.. returns "blob" in new-ish chrome.
    // plus.google.com/115535723976198353696/posts/ERN6zYozENV
    // github.com/Modernizr/Modernizr/issues/370

    Modernizr.addTest('websocketsbinary', function () {
        var protocol = 'https:' == location.protocol ? 'wss' : 'ws',
          protoBin;

        if ('WebSocket' in window) {
            protoBin = 'binaryType' in WebSocket.prototype
            if (protoBin) {
                return protoBin;
            }
            try {
                return !!(new WebSocket(protocol + '://.').binaryType);
            } catch (e) { }
        }

        return false;
    });

    /*!
    {
      "name": "Shared Workers",
      "property": "sharedworkers",
      "caniuse" : "sharedworkers",
      "tags": ["performance", "workers"],
      "builderAliases": ["workers_sharedworkers"],
      "notes": [{
        "name": "W3C Reference",
        "href": "https://www.w3.org/TR/workers/"
      }]
    }
    !*/
    /* DOC
    Detects support for the `SharedWorker` API from the Web Workers spec.
    */

    Modernizr.addTest('sharedworkers', 'SharedWorker' in window);


    /**
     * List of property values to set for css tests. See ticket #21
     * http://git.io/vUGl4
     *
     * @memberof Modernizr
     * @name Modernizr._prefixes
     * @optionName Modernizr._prefixes
     * @optionProp prefixes
     * @access public
     * @example
     *
     * Modernizr._prefixes is the internal list of prefixes that we test against
     * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
     * an array of kebab-case vendor prefixes you can use within your code.
     *
     * Some common use cases include
     *
     * Generating all possible prefixed version of a CSS property
     * ```js
     * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
     *
     * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
     * ```
     *
     * Generating all possible prefixed version of a CSS value
     * ```js
     * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
     *
     * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
     * ```
     */

    // we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
    // values in feature detects to continue to work
    var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['', '']);

    // expose these for the plugin API. Look in the source for how to join() them against your input
    ModernizrProto._prefixes = prefixes;



    /**
     * is returns a boolean if the typeof an obj is exactly type.
     *
     * @access private
     * @function is
     * @param {*} obj - A thing we want to check the type of
     * @param {string} type - A string to compare the typeof against
     * @returns {boolean}
     */

    function is(obj, type) {
        return typeof obj === type;
    }
    ;

    /**
     * Run through all tests and detect their support in the current UA.
     *
     * @access private
     */

    function testRunner() {
        var featureNames;
        var feature;
        var aliasIdx;
        var result;
        var nameIdx;
        var featureName;
        var featureNameSplit;

        for (var featureIdx in tests) {
            if (tests.hasOwnProperty(featureIdx)) {
                featureNames = [];
                feature = tests[featureIdx];
                // run the test, throw the return value into the Modernizr,
                // then based on that boolean, define an appropriate className
                // and push it into an array of classes we'll join later.
                //
                // If there is no name, it's an 'async' test that is run,
                // but not directly added to the object. That should
                // be done with a post-run addTest call.
                if (feature.name) {
                    featureNames.push(feature.name.toLowerCase());

                    if (feature.options && feature.options.aliases && feature.options.aliases.length) {
                        // Add all the aliases into the names list
                        for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
                            featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
                        }
                    }
                }

                // Run the test, or use the raw value if it's not a function
                result = is(feature.fn, 'function') ? feature.fn() : feature.fn;


                // Set each of the names on the Modernizr object
                for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
                    featureName = featureNames[nameIdx];
                    // Support dot properties as sub tests. We don't do checking to make sure
                    // that the implied parent tests have been added. You must call them in
                    // order (either in the test, or make the parent test a dependency).
                    //
                    // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
                    // hashtag famous last words
                    featureNameSplit = featureName.split('.');

                    if (featureNameSplit.length === 1) {
                        Modernizr[featureNameSplit[0]] = result;
                    } else {
                        // cast to a Boolean, if not one already
                        if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
                            Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
                        }

                        Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
                    }

                    classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
                }
            }
        }
    }
    ;

    /**
     * docElement is a convenience wrapper to grab the root element of the document
     *
     * @access private
     * @returns {HTMLElement|SVGElement} The root element of the document
     */

    var docElement = document.documentElement;

    /*!
    {
      "name": "Context menus",
      "property": "contextmenu",
      "caniuse": "menu",
      "notes": [{
        "name": "W3C spec",
        "href": "http://www.w3.org/TR/html5/interactive-elements.html#context-menus"
      },{
        "name": "thewebrocks.com Demo",
        "href": "http://thewebrocks.com/demos/context-menu/"
      }],
      "polyfills": ["jquery-contextmenu"]
    }
    !*/
    /* DOC
    Detects support for custom context menus.
    */

    Modernizr.addTest(
      'contextmenu',
      ('contextMenu' in docElement && 'HTMLMenuItemElement' in window)
    );

    /*!
    {
      "name": "cssall",
      "property": "cssall",
      "notes": [{
        "name": "Spec",
        "href": "https://drafts.csswg.org/css-cascade/#all-shorthand"
      }]
    }
    !*/
    /* DOC
    Detects support for the `all` css property, which is a shorthand to reset all css properties (except direction and unicode-bidi) to their original value
    */


    Modernizr.addTest('cssall', 'all' in docElement.style);

    /*!
    {
      "name": "will-change",
      "property": "willchange",
      "notes": [{
        "name": "Spec",
        "href": "https://drafts.csswg.org/css-will-change/"
      }]
    }
    !*/
    /* DOC
    Detects support for the `will-change` css property, which formally signals to the
    browser that an element will be animating.
    */

    Modernizr.addTest('willchange', 'willChange' in docElement.style);

    /*!
    {
      "name": "Document Fragment",
      "property": "documentfragment",
      "notes": [{
        "name": "W3C DOM Level 1 Reference",
        "href": "https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-B63ED1A3"
      }, {
        "name": "SitePoint Reference",
        "href": "http://reference.sitepoint.com/javascript/DocumentFragment"
      }, {
        "name": "QuirksMode Compatibility Tables",
        "href": "http://www.quirksmode.org/m/w3c_core.html#t112"
      }],
      "authors": ["Ron Waldon (@jokeyrhyme)"],
      "knownBugs": ["false-positive on Blackberry 9500, see QuirksMode note"],
      "tags": []
    }
    !*/
    /* DOC
    Append multiple elements to the DOM within a single insertion.
    */

    Modernizr.addTest('documentfragment', function () {
        return 'createDocumentFragment' in document &&
          'appendChild' in docElement;
    });


    /**
     * A convenience helper to check if the document we are running in is an SVG document
     *
     * @access private
     * @returns {boolean}
     */

    var isSVG = docElement.nodeName.toLowerCase() === 'svg';


    /**
     * setClasses takes an array of class names and adds them to the root element
     *
     * @access private
     * @function setClasses
     * @param {string[]} classes - Array of class names
     */

    // Pass in an and array of class names, e.g.:
    //  ['no-webp', 'borderradius', ...]
    function setClasses(classes) {
        var className = docElement.className;
        var classPrefix = Modernizr._config.classPrefix || '';

        if (isSVG) {
            className = className.baseVal;
        }

        // Change `no-js` to `js` (independently of the `enableClasses` option)
        // Handle classPrefix on this too
        if (Modernizr._config.enableJSClass) {
            var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
            className = className.replace(reJS, '$1' + classPrefix + 'js$2');
        }

        if (Modernizr._config.enableClasses) {
            // Add the new classes
            className += ' ' + classPrefix + classes.join(' ' + classPrefix);
            if (isSVG) {
                docElement.className.baseVal = className;
            } else {
                docElement.className = className;
            }
        }

    }

    ;

    /**
     * If the browsers follow the spec, then they would expose vendor-specific styles as:
     *   elem.style.WebkitBorderRadius
     * instead of something like the following (which is technically incorrect):
     *   elem.style.webkitBorderRadius
  
     * WebKit ghosts their properties in lowercase but Opera & Moz do not.
     * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
     *   erik.eae.net/archives/2008/03/10/21.48.10/
  
     * More here: github.com/Modernizr/Modernizr/issues/issue/21
     *
     * @access private
     * @returns {string} The string representing the vendor-specific style properties
     */

    var omPrefixes = 'Moz O ms Webkit';


    /**
     * List of JavaScript DOM values used for tests
     *
     * @memberof Modernizr
     * @name Modernizr._domPrefixes
     * @optionName Modernizr._domPrefixes
     * @optionProp domPrefixes
     * @access public
     * @example
     *
     * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
     * than kebab-case properties, all properties are their Capitalized variant
     *
     * ```js
     * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
     * ```
     */

    var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
    ModernizrProto._domPrefixes = domPrefixes;


    /**
     * hasOwnProp is a shim for hasOwnProperty that is needed for Safari 2.0 support
     *
     * @author kangax
     * @access private
     * @function hasOwnProp
     * @param {object} object - The object to check for a property
     * @param {string} property - The property to check for
     * @returns {boolean}
     */

    // hasOwnProperty shim by kangax needed for Safari 2.0 support
    var hasOwnProp;

    (function () {
        var _hasOwnProperty = ({}).hasOwnProperty;
        /* istanbul ignore else */
        /* we have no way of testing IE 5.5 or safari 2,
         * so just assume the else gets hit */
        if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
            hasOwnProp = function (object, property) {
                return _hasOwnProperty.call(object, property);
            };
        }
        else {
            hasOwnProp = function (object, property) { /* yes, this can give false positives/negatives, but most of the time we don't care about those */
                return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
            };
        }
    })();




    // _l tracks listeners for async tests, as well as tests that execute after the initial run
    ModernizrProto._l = {};

    /**
     * Modernizr.on is a way to listen for the completion of async tests. Being
     * asynchronous, they may not finish before your scripts run. As a result you
     * will get a possibly false negative `undefined` value.
     *
     * @memberof Modernizr
     * @name Modernizr.on
     * @access public
     * @function on
     * @param {string} feature - String name of the feature detect
     * @param {function} cb - Callback function returning a Boolean - true if feature is supported, false if not
     * @example
     *
     * ```js
     * Modernizr.on('flash', function( result ) {
     *   if (result) {
     *    // the browser has flash
     *   } else {
     *     // the browser does not have flash
     *   }
     * });
     * ```
     */

    ModernizrProto.on = function (feature, cb) {
        // Create the list of listeners if it doesn't exist
        if (!this._l[feature]) {
            this._l[feature] = [];
        }

        // Push this test on to the listener list
        this._l[feature].push(cb);

        // If it's already been resolved, trigger it on next tick
        if (Modernizr.hasOwnProperty(feature)) {
            // Next Tick
            setTimeout(function () {
                Modernizr._trigger(feature, Modernizr[feature]);
            }, 0);
        }
    };

    /**
     * _trigger is the private function used to signal test completion and run any
     * callbacks registered through [Modernizr.on](#modernizr-on)
     *
     * @memberof Modernizr
     * @name Modernizr._trigger
     * @access private
     * @function _trigger
     * @param {string} feature - string name of the feature detect
     * @param {function|boolean} [res] - A feature detection function, or the boolean =
     * result of a feature detection function
     */

    ModernizrProto._trigger = function (feature, res) {
        if (!this._l[feature]) {
            return;
        }

        var cbs = this._l[feature];

        // Force async
        setTimeout(function () {
            var i, cb;
            for (i = 0; i < cbs.length; i++) {
                cb = cbs[i];
                cb(res);
            }
        }, 0);

        // Don't trigger these again
        delete this._l[feature];
    };

    /**
     * addTest allows you to define your own feature detects that are not currently
     * included in Modernizr (under the covers it's the exact same code Modernizr
     * uses for its own [feature detections](https://github.com/Modernizr/Modernizr/tree/master/feature-detects)). Just like the offical detects, the result
     * will be added onto the Modernizr object, as well as an appropriate className set on
     * the html element when configured to do so
     *
     * @memberof Modernizr
     * @name Modernizr.addTest
     * @optionName Modernizr.addTest()
     * @optionProp addTest
     * @access public
     * @function addTest
     * @param {string|object} feature - The string name of the feature detect, or an
     * object of feature detect names and test
     * @param {function|boolean} test - Function returning true if feature is supported,
     * false if not. Otherwise a boolean representing the results of a feature detection
     * @example
     *
     * The most common way of creating your own feature detects is by calling
     * `Modernizr.addTest` with a string (preferably just lowercase, without any
     * punctuation), and a function you want executed that will return a boolean result
     *
     * ```js
     * Modernizr.addTest('itsTuesday', function() {
     *  var d = new Date();
     *  return d.getDay() === 2;
     * });
     * ```
     *
     * When the above is run, it will set Modernizr.itstuesday to `true` when it is tuesday,
     * and to `false` every other day of the week. One thing to notice is that the names of
     * feature detect functions are always lowercased when added to the Modernizr object. That
     * means that `Modernizr.itsTuesday` will not exist, but `Modernizr.itstuesday` will.
     *
     *
     *  Since we only look at the returned value from any feature detection function,
     *  you do not need to actually use a function. For simple detections, just passing
     *  in a statement that will return a boolean value works just fine.
     *
     * ```js
     * Modernizr.addTest('hasJquery', 'jQuery' in window);
     * ```
     *
     * Just like before, when the above runs `Modernizr.hasjquery` will be true if
     * jQuery has been included on the page. Not using a function saves a small amount
     * of overhead for the browser, as well as making your code much more readable.
     *
     * Finally, you also have the ability to pass in an object of feature names and
     * their tests. This is handy if you want to add multiple detections in one go.
     * The keys should always be a string, and the value can be either a boolean or
     * function that returns a boolean.
     *
     * ```js
     * var detects = {
     *  'hasjquery': 'jQuery' in window,
     *  'itstuesday': function() {
     *    var d = new Date();
     *    return d.getDay() === 2;
     *  }
     * }
     *
     * Modernizr.addTest(detects);
     * ```
     *
     * There is really no difference between the first methods and this one, it is
     * just a convenience to let you write more readable code.
     */

    function addTest(feature, test) {

        if (typeof feature == 'object') {
            for (var key in feature) {
                if (hasOwnProp(feature, key)) {
                    addTest(key, feature[key]);
                }
            }
        } else {

            feature = feature.toLowerCase();
            var featureNameSplit = feature.split('.');
            var last = Modernizr[featureNameSplit[0]];

            // Again, we don't check for parent test existence. Get that right, though.
            if (featureNameSplit.length == 2) {
                last = last[featureNameSplit[1]];
            }

            if (typeof last != 'undefined') {
                // we're going to quit if you're trying to overwrite an existing test
                // if we were to allow it, we'd do this:
                //   var re = new RegExp("\\b(no-)?" + feature + "\\b");
                //   docElement.className = docElement.className.replace( re, '' );
                // but, no rly, stuff 'em.
                return Modernizr;
            }

            test = typeof test == 'function' ? test() : test;

            // Set the value (this is the magic, right here).
            if (featureNameSplit.length == 1) {
                Modernizr[featureNameSplit[0]] = test;
            } else {
                // cast to a Boolean, if not one already
                if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
                    Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
                }

                Modernizr[featureNameSplit[0]][featureNameSplit[1]] = test;
            }

            // Set a single class (either `feature` or `no-feature`)
            setClasses([(!!test && test != false ? '' : 'no-') + featureNameSplit.join('-')]);

            // Trigger the event
            Modernizr._trigger(feature, test);
        }

        return Modernizr; // allow chaining.
    }

    // After all the tests are run, add self to the Modernizr prototype
    Modernizr._q.push(function () {
        ModernizrProto.addTest = addTest;
    });



    /*!
    {
      "authors": ["Cătălin Mariș"],
      "caniuse": "proximity",
      "name": "Proximity API",
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Proximity_Events"
      },{
        "name": "W3C specification",
        "href": "https://www.w3.org/TR/proximity/"
      }],
      "property": "proximity",
      "tags": ["events", "proximity"]
    }
    !*/
    /* DOC
    Detects support for an API that allows users to get proximity related information from the device's proximity sensor.
    */


    Modernizr.addAsyncTest(function () {

        var timeout;
        var timeoutTime = 300;

        function advertiseSupport() {

            // Clean up after ourselves
            clearTimeout(timeout);
            window.removeEventListener('deviceproximity', advertiseSupport);

            // Advertise support as the browser supports
            // the API and the device has a proximity sensor
            addTest('proximity', true);

        }

        // Check if the browser has support for the API
        if ('ondeviceproximity' in window && 'onuserproximity' in window) {

            // Check if the device has a proximity sensor
            // ( devices without such a sensor support the events but
            //   will never fire them resulting in a false positive )
            window.addEventListener('deviceproximity', advertiseSupport);

            // If the event doesn't fire in a reasonable amount of time,
            // it means that the device doesn't have a proximity sensor,
            // thus, we can advertise the "lack" of support
            timeout = setTimeout(function () {
                window.removeEventListener('deviceproximity', advertiseSupport);
                addTest('proximity', false);
            }, timeoutTime);

        } else {
            addTest('proximity', false);
        }

    });


    /*!
    {
      "name": "Workers from Blob URIs",
      "property": "blobworkers",
      "tags": ["performance", "workers"],
      "builderAliases": ["workers_blobworkers"],
      "notes": [{
        "name": "W3C Reference",
        "href": "https://www.w3.org/TR/workers/"
      }],
      "knownBugs": ["This test may output garbage to console."],
      "authors": ["Jussi Kalliokoski"],
      "async": true
    }
    !*/
    /* DOC
    Detects support for creating Web Workers from Blob URIs.
    */

    Modernizr.addAsyncTest(function () {
        try {
            // we're avoiding using Modernizr._domPrefixes as the prefix capitalization on
            // these guys are notoriously peculiar.
            var BlobBuilder = window.BlobBuilder;
            var URL = window.URL;
            if (Modernizr._config.usePrefix) {
                BlobBuilder = BlobBuilder || window.MozBlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder || window.OBlobBuilder;
                URL = URL || window.MozURL || window.webkitURL || window.MSURL || window.OURL;
            }
            var data = 'Modernizr',
              blob,
              bb,
              worker,
              url,
              timeout,
              scriptText = 'this.onmessage=function(e){postMessage(e.data)}';

            try {
                blob = new Blob([scriptText], { type: 'text/javascript' });
            } catch (e) {
                // we'll fall back to the deprecated BlobBuilder
            }
            if (!blob) {
                bb = new BlobBuilder();
                bb.append(scriptText);
                blob = bb.getBlob();
            }

            url = URL.createObjectURL(blob);
            worker = new Worker(url);

            worker.onmessage = function (e) {
                addTest('blobworkers', data === e.data);
                cleanup();
            };

            // Just in case...
            worker.onerror = fail;
            timeout = setTimeout(fail, 200);

            worker.postMessage(data);
        } catch (e) {
            fail();
        }

        function fail() {
            addTest('blobworkers', false);
            cleanup();
        }

        function cleanup() {
            if (url) {
                URL.revokeObjectURL(url);
            }
            if (worker) {
                worker.terminate();
            }
            if (timeout) {
                clearTimeout(timeout);
            }
        }
    });

    /*!
    {
      "name": "Workers from Data URIs",
      "property": "dataworkers",
      "tags": ["performance", "workers"],
      "builderAliases": ["workers_dataworkers"],
      "notes": [{
        "name": "W3C Reference",
        "href": "https://www.w3.org/TR/workers/"
      }],
      "knownBugs": ["This test may output garbage to console."],
      "authors": ["Jussi Kalliokoski"],
      "async": true
    }
    !*/
    /* DOC
    Detects support for creating Web Workers from Data URIs.
    */

    Modernizr.addAsyncTest(function () {
        try {
            var data = 'Modernizr',
              worker = new Worker('data:text/javascript;base64,dGhpcy5vbm1lc3NhZ2U9ZnVuY3Rpb24oZSl7cG9zdE1lc3NhZ2UoZS5kYXRhKX0=');

            worker.onmessage = function (e) {
                worker.terminate();
                addTest('dataworkers', data === e.data);
                worker = null;
            };

            // Just in case...
            worker.onerror = function () {
                addTest('dataworkers', false);
                worker = null;
            };

            setTimeout(function () {
                addTest('dataworkers', false);
            }, 200);

            worker.postMessage(data);
        } catch (e) {
            setTimeout(function () {
                addTest('dataworkers', false);
            }, 0);
        }
    });

    /*!
    {
      "name": "Webp",
      "async": true,
      "property": "webp",
      "tags": ["image"],
      "builderAliases": ["img_webp"],
      "authors": ["Krister Kari", "@amandeep", "Rich Bradshaw", "Ryan Seddon", "Paul Irish"],
      "notes": [{
        "name": "Webp Info",
        "href": "https://developers.google.com/speed/webp/"
      }, {
        "name": "Chormium blog - Chrome 32 Beta: Animated WebP images and faster Chrome for Android touch input",
        "href": "https://blog.chromium.org/2013/11/chrome-32-beta-animated-webp-images-and.html"
      }, {
        "name": "Webp Lossless Spec",
        "href": "https://developers.google.com/speed/webp/docs/webp_lossless_bitstream_specification"
      }, {
        "name": "Article about WebP support on Android browsers",
        "href": "http://www.wope-framework.com/en/2013/06/24/webp-support-on-android-browsers/"
      }, {
        "name": "Chormium WebP announcement",
        "href": "https://blog.chromium.org/2011/11/lossless-and-transparency-encoding-in.html?m=1"
      }]
    }
    !*/
    /* DOC
    Tests for lossy, non-alpha webp support.
    
    Tests for all forms of webp support (lossless, lossy, alpha, and animated)..
    
      Modernizr.webp              // Basic support (lossy)
      Modernizr.webp.lossless     // Lossless
      Modernizr.webp.alpha        // Alpha (both lossy and lossless)
      Modernizr.webp.animation    // Animated WebP
    
    */


    Modernizr.addAsyncTest(function () {

        var webpTests = [{
            'uri': 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=',
            'name': 'webp'
        }, {
            'uri': 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==',
            'name': 'webp.alpha'
        }, {
            'uri': 'data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
            'name': 'webp.animation'
        }, {
            'uri': 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=',
            'name': 'webp.lossless'
        }];

        var webp = webpTests.shift();
        function test(name, uri, cb) {

            var image = new Image();

            function addResult(event) {
                // if the event is from 'onload', check the see if the image's width is
                // 1 pixel (which indiciates support). otherwise, it fails

                var result = event && event.type === 'load' ? image.width == 1 : false;
                var baseTest = name === 'webp';

                // if it is the base test, and the result is false, just set a literal false
                // rather than use the Boolean contrsuctor
                addTest(name, (baseTest && result) ? new Boolean(result) : result);

                if (cb) {
                    cb(event);
                }
            }

            image.onerror = addResult;
            image.onload = addResult;

            image.src = uri;
        }

        // test for webp support in general
        test(webp.name, webp.uri, function (e) {
            // if the webp test loaded, test everything else.
            if (e && e.type === 'load') {
                for (var i = 0; i < webpTests.length; i++) {
                    test(webpTests[i].name, webpTests[i].uri);
                }
            }
        });

    });



    var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
    ModernizrProto._cssomPrefixes = cssomPrefixes;


    /**
     * atRule returns a given CSS property at-rule (eg @keyframes), possibly in
     * some prefixed form, or false, in the case of an unsupported rule
     *
     * @memberof Modernizr
     * @name Modernizr.atRule
     * @optionName Modernizr.atRule()
     * @optionProp atRule
     * @access public
     * @function atRule
     * @param {string} prop - String name of the @-rule to test for
     * @returns {string|boolean} The string representing the (possibly prefixed)
     * valid version of the @-rule, or `false` when it is unsupported.
     * @example
     * ```js
     *  var keyframes = Modernizr.atRule('@keyframes');
     *
     *  if (keyframes) {
     *    // keyframes are supported
     *    // could be `@-webkit-keyframes` or `@keyframes`
     *  } else {
     *    // keyframes === `false`
     *  }
     * ```
     *
     */

    var atRule = function (prop) {
        var length = prefixes.length;
        var cssrule = window.CSSRule;
        var rule;

        if (typeof cssrule === 'undefined') {
            return undefined;
        }

        if (!prop) {
            return false;
        }

        // remove literal @ from beginning of provided property
        prop = prop.replace(/^@/, '');

        // CSSRules use underscores instead of dashes
        rule = prop.replace(/-/g, '_').toUpperCase() + '_RULE';

        if (rule in cssrule) {
            return '@' + prop;
        }

        for (var i = 0; i < length; i++) {
            // prefixes gives us something like -o-, and we want O_
            var prefix = prefixes[i];
            var thisRule = prefix.toUpperCase() + '_' + rule;

            if (thisRule in cssrule) {
                return '@-' + prefix.toLowerCase() + '-' + prop;
            }
        }

        return false;
    };

    ModernizrProto.atRule = atRule;



    /**
     * createElement is a convenience wrapper around document.createElement. Since we
     * use createElement all over the place, this allows for (slightly) smaller code
     * as well as abstracting away issues with creating elements in contexts other than
     * HTML documents (e.g. SVG documents).
     *
     * @access private
     * @function createElement
     * @returns {HTMLElement|SVGElement} An HTML or SVG element
     */

    function createElement() {
        if (typeof document.createElement !== 'function') {
            // This is the case in IE7, where the type of createElement is "object".
            // For this reason, we cannot call apply() as Object is not a Function.
            return document.createElement(arguments[0]);
        } else if (isSVG) {
            return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
        } else {
            return document.createElement.apply(document, arguments);
        }
    }

    ;

    /**
     * Modernizr.hasEvent() detects support for a given event
     *
     * @memberof Modernizr
     * @name Modernizr.hasEvent
     * @optionName Modernizr.hasEvent()
     * @optionProp hasEvent
     * @access public
     * @function hasEvent
     * @param  {string|*} eventName - the name of an event to test for (e.g. "resize")
     * @param  {Element|string} [element=HTMLDivElement] - is the element|document|window|tagName to test on
     * @returns {boolean}
     * @example
     *  `Modernizr.hasEvent` lets you determine if the browser supports a supplied event.
     *  By default, it does this detection on a div element
     *
     * ```js
     *  hasEvent('blur') // true;
     * ```
     *
     * However, you are able to give an object as a second argument to hasEvent to
     * detect an event on something other than a div.
     *
     * ```js
     *  hasEvent('devicelight', window) // true;
     * ```
     *
     */

    var hasEvent = (function () {

        // Detect whether event support can be detected via `in`. Test on a DOM element
        // using the "blur" event b/c it should always exist. bit.ly/event-detection
        var needsFallback = !('onblur' in document.documentElement);

        function inner(eventName, element) {

            var isSupported;
            if (!eventName) { return false; }
            if (!element || typeof element === 'string') {
                element = createElement(element || 'div');
            }

            // Testing via the `in` operator is sufficient for modern browsers and IE.
            // When using `setAttribute`, IE skips "unload", WebKit skips "unload" and
            // "resize", whereas `in` "catches" those.
            eventName = 'on' + eventName;
            isSupported = eventName in element;

            // Fallback technique for old Firefox - bit.ly/event-detection
            if (!isSupported && needsFallback) {
                if (!element.setAttribute) {
                    // Switch to generic element if it lacks `setAttribute`.
                    // It could be the `document`, `window`, or something else.
                    element = createElement('div');
                }

                element.setAttribute(eventName, '');
                isSupported = typeof element[eventName] === 'function';

                if (element[eventName] !== undefined) {
                    // If property was created, "remove it" by setting value to `undefined`.
                    element[eventName] = undefined;
                }
                element.removeAttribute(eventName);
            }

            return isSupported;
        }
        return inner;
    })();


    ModernizrProto.hasEvent = hasEvent;

    /*!
    {
      "name": "Hashchange event",
      "property": "hashchange",
      "caniuse": "hashchange",
      "tags": ["history"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/window.onhashchange"
      }],
      "polyfills": [
        "jquery-hashchange",
        "moo-historymanager",
        "jquery-ajaxy",
        "hasher",
        "shistory"
      ]
    }
    !*/
    /* DOC
    Detects support for the `hashchange` event, fired when the current location fragment changes.
    */

    Modernizr.addTest('hashchange', function () {
        if (hasEvent('hashchange', window) === false) {
            return false;
        }

        // documentMode logic from YUI to filter out IE8 Compat Mode
        //   which false positives.
        return (document.documentMode === undefined || document.documentMode > 7);
    });

    /*!
    {
      "name": "input[search] search event",
      "property": "search",
      "tags": ["input","search"],
      "authors": ["Calvin Webster"],
      "notes": [{
        "name": "Wufoo demo",
        "href": "https://www.wufoo.com/html5/types/5-search.html?"
      }, {
        "name": "CSS Tricks",
        "href": "https://css-tricks.com/webkit-html5-search-inputs/"
      }]
    }
    !*/
    /* DOC
    There is a custom `search` event implemented in webkit browsers when using an `input[search]` element.
    */

    Modernizr.addTest('inputsearchevent', hasEvent('search'));

    /*!
    {
      "name": "DOM Pointer Events API",
      "property": "pointerevents",
      "tags": ["input"],
      "authors": ["Stu Cox"],
      "notes": [
        {
          "name": "W3C spec",
          "href": "https://www.w3.org/TR/pointerevents/"
        }
      ],
      "warnings": ["This property name now refers to W3C DOM PointerEvents: https://github.com/Modernizr/Modernizr/issues/548#issuecomment-12812099"],
      "polyfills": ["handjs","pep"]
    }
    !*/
    /* DOC
    Detects support for the DOM Pointer Events API, which provides a unified event interface for pointing input devices, as implemented in IE10+.
    */

    // **Test name hijacked!**
    // Now refers to W3C DOM PointerEvents spec rather than the CSS pointer-events property.
    Modernizr.addTest('pointerevents', function () {
        // Cannot use `.prefixed()` for events, so test each prefix
        var bool = false,
          i = domPrefixes.length;

        // Don't forget un-prefixed...
        bool = Modernizr.hasEvent('pointerdown');

        while (i-- && !bool) {
            if (hasEvent(domPrefixes[i] + 'pointerdown')) {
                bool = true;
            }
        }
        return bool;
    });


    /**
     * prefixedCSSValue is a way test for prefixed css properties (e.g. display: -webkit-flex)
     *
     * @memberof Modernizr
     * @name Modernizr.prefixedCSSValue
     * @optionName Modernizr.prefixedCSSValue()
     * @optionProp prefixedCSSValue
     * @access public
     * @function prefixedCSSValue
     * @param {string} prop - String name of the property to test for
     * @param {string} value - String value of the non prefixed version of the value you want to test for
     * @returns {string|false} The string representing the (possibly prefixed)
     * valid version of the property, or `false` when it is unsupported.
     * @example
     *
     * `Modernizr.prefixedCSSValue` is a way test for prefixed css properties (e.g. display: -webkit-flex)
     *
     * ```js
     * Modernizr.prefixedCSSValue('background', 'linear-gradient(left, red, red)')
     * ```
     *
     */

    var prefixedCSSValue = function (prop, value) {
        var result = false;
        var elem = createElement('div');
        var style = elem.style;

        if (prop in style) {
            var i = domPrefixes.length;

            style[prop] = value;
            result = style[prop];

            while (i-- && !result) {
                style[prop] = '-' + domPrefixes[i] + '-' + value;
                result = style[prop];
            }
        }

        if (result === '') {
            result = false;
        }

        return result;
    };

    ModernizrProto.prefixedCSSValue = prefixedCSSValue;

    /*!
    {
      "name": "Content Editable",
      "property": "contenteditable",
      "caniuse": "contenteditable",
      "notes": [{
        "name": "WHATWG spec",
        "href": "https://html.spec.whatwg.org/multipage/interaction.html#contenteditable"
      }]
    }
    !*/
    /* DOC
    Detects support for the `contenteditable` attribute of elements, allowing their DOM text contents to be edited directly by the user.
    */

    Modernizr.addTest('contenteditable', function () {
        // early bail out
        if (!('contentEditable' in docElement)) {
            return;
        }

        // some mobile browsers (android < 3.0, iOS < 5) claim to support
        // contentEditable, but but don't really. This test checks to see
        // confirms whether or not it actually supports it.

        var div = createElement('div');
        div.contentEditable = true;
        return div.contentEditable === 'true';
    });

    /*!
    {
      "name": "HTML Imports",
      "notes": [
        {
          "name": "W3C HTML Imports Specification",
          "href": "https://w3c.github.io/webcomponents/spec/imports/"
        },
        {
          "name": "HTML Imports - #include for the web",
          "href": "http://www.html5rocks.com/en/tutorials/webcomponents/imports/"
        }
      ],
      "polyfills": ["polymer-htmlimports"],
      "property": "htmlimports",
      "tags": ["html", "import"]
    }
    !*/
    /* DOC
    Detects support for HTML import, a feature that is used for loading in Web Components.
     */


    addTest('htmlimports', 'import' in createElement('link'));

    /*!
    {
      "name": "Reverse Ordered Lists",
      "property": "olreversed",
      "notes": [{
        "name": "Impressive Webs article",
        "href": "http://impressivewebs.com/reverse-ordered-lists-html5"
      }],
      "builderAliases": ["lists_reversed"]
    }
    !*/
    /* DOC
    Detects support for the `reversed` attribute on the `<ol>` element.
    */

    Modernizr.addTest('olreversed', 'reversed' in createElement('ol'));

    /*!
    {
      "name": "Web Animation API",
      "property": "animation",
      "tags": ["webanimations"],
      "polyfills": ["webanimationsjs"],
      "notes": [{
        "name": "Introducing Web Animations",
        "href": "http://brian.sol1.net/svg/2013/06/26/introducing-web-animations/"
      }]
    }
    !*/
    /* DOC
    Detects support for the Web Animation API, a way to create css animations in js
    */

    Modernizr.addTest('webanimations', 'animate' in createElement('div'));

    /*!
    {
      "name": "WebGL",
      "property": "webgl",
      "caniuse": "webgl",
      "tags": ["webgl", "graphics"],
      "polyfills": ["jebgl", "cwebgl", "iewebgl"]
    }
    !*/

    Modernizr.addTest('webgl', function () {
        var canvas = createElement('canvas');
        var supports = 'probablySupportsContext' in canvas ? 'probablySupportsContext' : 'supportsContext';
        if (supports in canvas) {
            return canvas[supports]('webgl') || canvas[supports]('experimental-webgl');
        }
        return 'WebGLRenderingContext' in window;
    });

    /*!
    {
      "name": "a[download] Attribute",
      "property": "adownload",
      "caniuse" : "download",
      "tags": ["media", "attribute"],
      "builderAliases": ["a_download"],
      "notes": [{
        "name": "WhatWG Reference",
        "href": "https://developers.whatwg.org/links.html#downloading-resources"
      }]
    }
    !*/
    /* DOC
    When used on an `<a>`, this attribute signifies that the resource it points to should be downloaded by the browser rather than navigating to it.
    */

    Modernizr.addTest('adownload', !window.externalHost && 'download' in createElement('a'));

    /*!
    {
      "name": "CSS Pointer Events",
      "caniuse": "pointer-events",
      "property": "csspointerevents",
      "authors": ["ausi"],
      "tags": ["css"],
      "builderAliases": ["css_pointerevents"],
      "notes": [
        {
          "name": "MDN Docs",
          "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/pointer-events"
        },{
          "name": "Test Project Page",
          "href": "https://ausi.github.com/Feature-detection-technique-for-pointer-events/"
        },{
          "name": "Test Project Wiki",
          "href": "https://github.com/ausi/Feature-detection-technique-for-pointer-events/wiki"
        },
        {
          "name": "Related Github Issue",
          "href": "https://github.com/Modernizr/Modernizr/issues/80"
        }
      ]
    }
    !*/

    Modernizr.addTest('csspointerevents', function () {
        var style = createElement('a').style;
        style.cssText = 'pointer-events:auto';
        return style.pointerEvents === 'auto';
    });

    /*!
    {
      "name": "CSS Transform Style preserve-3d",
      "property": "preserve3d",
      "authors": ["denyskoch", "aFarkas"],
      "tags": ["css"],
      "notes": [{
        "name": "MDN Docs",
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/transform-style"
      },{
        "name": "Related Github Issue",
        "href": "https://github.com/Modernizr/Modernizr/issues/1748"
      }]
    }
    !*/
    /* DOC
    Detects support for `transform-style: preserve-3d`, for getting a proper 3D perspective on elements.
    */

    Modernizr.addTest('preserve3d', function () {
        var outerAnchor, innerAnchor;
        var CSS = window.CSS;
        var result = false;

        if (CSS && CSS.supports && CSS.supports('(transform-style: preserve-3d)')) {
            return true;
        }

        outerAnchor = createElement('a');
        innerAnchor = createElement('a');

        outerAnchor.style.cssText = 'display: block; transform-style: preserve-3d; transform-origin: right; transform: rotateY(40deg);';
        innerAnchor.style.cssText = 'display: block; width: 9px; height: 1px; background: #000; transform-origin: right; transform: rotateY(40deg);';

        outerAnchor.appendChild(innerAnchor);
        docElement.appendChild(outerAnchor);

        result = innerAnchor.getBoundingClientRect();
        docElement.removeChild(outerAnchor);

        result = result.width && result.width < 4;
        return result;
    });

    /*!
    {
      "name": "output Element",
      "property": "outputelem",
      "tags": ["elem"],
      "builderAliases": ["elem_output"],
      "notes": [{
        "name": "WhatWG Spec",
        "href": "https://html.spec.whatwg.org/multipage/forms.html#the-output-element"
      }]
    }
    !*/

    Modernizr.addTest('outputelem', 'value' in createElement('output'));

    /*!
    {
      "name": "Template Tag",
      "property": "template",
      "tags": ["elem"],
      "notes": [{
        "name": "HTML5Rocks Article",
        "href": "http://www.html5rocks.com/en/tutorials/webcomponents/template/"
      },{
        "name": "W3 Spec",
        "href": "https://dvcs.w3.org/hg/webcomponents/raw-file/tip/spec/templates/index.html"
      }]
    }
    !*/

    Modernizr.addTest('template', 'content' in createElement('template'));

    /*!
    {
      "name": "Track element and Timed Text Track",
      "property": ["texttrackapi", "track"],
      "tags": ["elem"],
      "builderAliases": ["elem_track"],
      "authors": ["Addy Osmani"],
      "notes": [{
        "name": "W3 track Element Spec",
        "href": "http://www.w3.org/TR/html5/video.html#the-track-element"
      },{
        "name": "W3 track API Spec",
        "href": "http://www.w3.org/TR/html5/media-elements.html#text-track-api"
      }],
      "warnings": ["While IE10 has implemented the track element, IE10 does not expose the underlying APIs to create timed text tracks by JS (really sad)"]
    }
    !*/

    Modernizr.addTest('texttrackapi', typeof (createElement('video').addTextTrack) === 'function');

    // a more strict test for track including UI support: document.createElement('track').kind === 'subtitles'
    Modernizr.addTest('track', 'kind' in createElement('track'));

    /*!
    {
      "name": "Unknown Elements",
      "property": "unknownelements",
      "tags": ["elem"],
      "notes": [{
        "name": "The Story of the HTML5 Shiv",
        "href": "https://www.paulirish.com/2011/the-history-of-the-html5-shiv/"
      }, {
        "name": "original implementation of detect code",
        "href": "https://github.com/aFarkas/html5shiv/blob/bf4fcc4/src/html5shiv.js#L36"
      }],
      "polyfills": ["html5shiv"],
      "authors": ["Ron Waldon (@jokeyrhyme)"]
    }
    !*/
    /* DOC
    Does the browser support HTML with non-standard / new elements?
    */

    Modernizr.addTest('unknownelements', function () {
        var a = createElement('a');
        a.innerHTML = '<xyz></xyz>';
        return a.childNodes.length === 1;
    });

    /*!
    {
      "name": "placeholder attribute",
      "property": "placeholder",
      "tags": ["forms", "attribute"],
      "builderAliases": ["forms_placeholder"]
    }
    !*/
    /* DOC
    Tests for placeholder attribute in inputs and textareas
    */

    Modernizr.addTest('placeholder', ('placeholder' in createElement('input') && 'placeholder' in createElement('textarea')));


    /**
     * cssToDOM takes a kebab-case string and converts it to camelCase
     * e.g. box-sizing -> boxSizing
     *
     * @access private
     * @function cssToDOM
     * @param {string} name - String name of kebab-case prop we want to convert
     * @returns {string} The camelCase version of the supplied name
     */

    function cssToDOM(name) {
        return name.replace(/([a-z])-([a-z])/g, function (str, m1, m2) {
            return m1 + m2.toUpperCase();
        }).replace(/^-/, '');
    }
    ;

    /**
     * domToCSS takes a camelCase string and converts it to kebab-case
     * e.g. boxSizing -> box-sizing
     *
     * @access private
     * @function domToCSS
     * @param {string} name - String name of camelCase prop we want to convert
     * @returns {string} The kebab-case version of the supplied name
     */

    function domToCSS(name) {
        return name.replace(/([A-Z])/g, function (str, m1) {
            return '-' + m1.toLowerCase();
        }).replace(/^ms-/, '-ms-');
    }
    ;

    /**
     * getBody returns the body of a document, or an element that can stand in for
     * the body if a real body does not exist
     *
     * @access private
     * @function getBody
     * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
     * artificially created element that stands in for the body
     */

    function getBody() {
        // After page load injecting a fake body doesn't work so check if body exists
        var body = document.body;

        if (!body) {
            // Can't use the real body create a fake one.
            body = createElement(isSVG ? 'svg' : 'body');
            body.fake = true;
        }

        return body;
    }

    ;
    /*!
      {
      "name": "Flash",
      "property": "flash",
      "tags": ["flash"],
      "polyfills": ["shumway"]
      }
      !*/
    /* DOC
    Detects Flash support as well as Flash-blocking plugins
    */

    Modernizr.addAsyncTest(function () {

        var attachBody = function (body) {
            if (!docElement.contains(body)) {
                docElement.appendChild(body);
            }
        };
        var removeFakeBody = function (body) {
            // If we’re rockin’ an attached fake body, clean it up
            if (body.fake && body.parentNode) {
                body.parentNode.removeChild(body);
            }
        };
        var runTest = function (result, embed) {
            var bool = !!result;
            if (bool) {
                bool = new Boolean(bool);
                bool.blocked = (result === 'blocked');
            }
            addTest('flash', function () { return bool; });

            if (embed && body.contains(embed)) {

                // in case embed has been wrapped, as with ClickToPlugin
                while (embed.parentNode !== body) {
                    embed = embed.parentNode;
                }

                body.removeChild(embed);
            }

        };
        var easy_detect;
        var activex;
        // we wrap activex in a try/catch because when Flash is disabled through
        // ActiveX controls, it throws an error.
        try {
            // Pan is an API that exists for Flash objects.
            activex = 'ActiveXObject' in window && 'Pan' in new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash');
        } catch (e) { }

        easy_detect = !(('plugins' in navigator && 'Shockwave Flash' in navigator.plugins) || activex);

        if (easy_detect || isSVG) {
            runTest(false);
        }
        else {
            // Flash seems to be installed, but it might be blocked. We have to
            // actually create an element to see what happens to it.
            var embed = createElement('embed');
            var body = getBody();
            var blockedDetect;
            var inline_style;

            embed.type = 'application/x-shockwave-flash';

            // Need to do this in the body (fake or otherwise) otherwise IE8 complains
            body.appendChild(embed);

            // Pan doesn't exist in the embed if its IE (its on the ActiveXObjeect)
            // so this check is for all other browsers.
            if (!('Pan' in embed) && !activex) {
                attachBody(body);
                runTest('blocked', embed);
                removeFakeBody(body);
                return;
            }

            blockedDetect = function () {
                // if we used a fake body originally, we need to restart this test, since
                // we haven't been attached to the DOM, and therefore none of the blockers
                // have had time to work.
                attachBody(body);
                if (!docElement.contains(body)) {
                    body = document.body || body;
                    embed = createElement('embed');
                    embed.type = 'application/x-shockwave-flash';
                    body.appendChild(embed);
                    return setTimeout(blockedDetect, 1000);
                }
                if (!docElement.contains(embed)) {
                    runTest('blocked');
                }
                else {
                    inline_style = embed.style.cssText;
                    if (inline_style !== '') {
                        // the style of the element has changed automatically. This is a
                        // really poor heuristic, but for lower end Flash blocks, it the
                        // only change they can make.
                        runTest('blocked', embed);
                    }
                    else {
                        runTest(true, embed);
                    }
                }
                removeFakeBody(body);
            };

            // If we have got this far, there is still a chance a userland plugin
            // is blocking us (either changing the styles, or automatically removing
            // the element). Both of these require us to take a step back for a moment
            // to allow for them to get time of the thread, hence a setTimeout.
            //
            setTimeout(blockedDetect, 10);
        }
    });


    /**
     * injectElementWithStyles injects an element with style element and some CSS rules
     *
     * @access private
     * @function injectElementWithStyles
     * @param {string} rule - String representing a css rule
     * @param {function} callback - A function that is used to test the injected element
     * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
     * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
     * @returns {boolean}
     */

    function injectElementWithStyles(rule, callback, nodes, testnames) {
        var mod = 'modernizr';
        var style;
        var ret;
        var node;
        var docOverflow;
        var div = createElement('div');
        var body = getBody();

        if (parseInt(nodes, 10)) {
            // In order not to give false positives we create a node for each test
            // This also allows the method to scale for unspecified uses
            while (nodes--) {
                node = createElement('div');
                node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
                div.appendChild(node);
            }
        }

        style = createElement('style');
        style.type = 'text/css';
        style.id = 's' + mod;

        // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
        // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
        (!body.fake ? div : body).appendChild(style);
        body.appendChild(div);

        if (style.styleSheet) {
            style.styleSheet.cssText = rule;
        } else {
            style.appendChild(document.createTextNode(rule));
        }
        div.id = mod;

        if (body.fake) {
            //avoid crashing IE8, if background image is used
            body.style.background = '';
            //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
            body.style.overflow = 'hidden';
            docOverflow = docElement.style.overflow;
            docElement.style.overflow = 'hidden';
            docElement.appendChild(body);
        }

        ret = callback(div, rule);
        // If this is done after page load we don't want to remove the body so check if body exists
        if (body.fake) {
            body.parentNode.removeChild(body);
            docElement.style.overflow = docOverflow;
            // Trigger layout so kinetic scrolling isn't disabled in iOS6+
            // eslint-disable-next-line
            docElement.offsetHeight;
        } else {
            div.parentNode.removeChild(div);
        }

        return !!ret;

    }

    ;

    /**
     * Modernizr.mq tests a given media query, live against the current state of the window
     * adapted from matchMedia polyfill by Scott Jehl and Paul Irish
     * gist.github.com/786768
     *
     * @memberof Modernizr
     * @name Modernizr.mq
     * @optionName Modernizr.mq()
     * @optionProp mq
     * @access public
     * @function mq
     * @param {string} mq - String of the media query we want to test
     * @returns {boolean}
     * @example
     * Modernizr.mq allows for you to programmatically check if the current browser
     * window state matches a media query.
     *
     * ```js
     *  var query = Modernizr.mq('(min-width: 900px)');
     *
     *  if (query) {
     *    // the browser window is larger than 900px
     *  }
     * ```
     *
     * Only valid media queries are supported, therefore you must always include values
     * with your media query
     *
     * ```js
     * // good
     *  Modernizr.mq('(min-width: 900px)');
     *
     * // bad
     *  Modernizr.mq('min-width');
     * ```
     *
     * If you would just like to test that media queries are supported in general, use
     *
     * ```js
     *  Modernizr.mq('only all'); // true if MQ are supported, false if not
     * ```
     *
     *
     * Note that if the browser does not support media queries (e.g. old IE) mq will
     * always return false.
     */

    var mq = (function () {
        var matchMedia = window.matchMedia || window.msMatchMedia;
        if (matchMedia) {
            return function (mq) {
                var mql = matchMedia(mq);
                return mql && mql.matches || false;
            };
        }

        return function (mq) {
            var bool = false;

            injectElementWithStyles('@media ' + mq + ' { #modernizr { position: absolute; } }', function (node) {
                bool = (window.getComputedStyle ?
                        window.getComputedStyle(node, null) :
                        node.currentStyle).position == 'absolute';
            });

            return bool;
        };
    })();


    ModernizrProto.mq = mq;



    /**
     * testStyles injects an element with style element and some CSS rules
     *
     * @memberof Modernizr
     * @name Modernizr.testStyles
     * @optionName Modernizr.testStyles()
     * @optionProp testStyles
     * @access public
     * @function testStyles
     * @param {string} rule - String representing a css rule
     * @param {function} callback - A function that is used to test the injected element
     * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
     * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
     * @returns {boolean}
     * @example
     *
     * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
     * along with (possibly multiple) DOM elements. This lets you check for features
     * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
     *
     * ```js
     * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
     *   // elem is the first DOM node in the page (by default #modernizr)
     *   // rule is the first argument you supplied - the CSS rule in string form
     *
     *   addTest('widthworks', elem.style.width === '9px')
     * });
     * ```
     *
     * If your test requires multiple nodes, you can include a third argument
     * indicating how many additional div elements to include on the page. The
     * additional nodes are injected as children of the `elem` that is returned as
     * the first argument to the callback.
     *
     * ```js
     * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
     *   document.getElementById('modernizr').style.width === '1px'; // true
     *   document.getElementById('modernizr2').style.width === '2px'; // true
     *   elem.firstChild === document.getElementById('modernizr2'); // true
     * }, 1);
     * ```
     *
     * By default, all of the additional elements have an ID of `modernizr[n]`, where
     * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
     * the second additional is `#modernizr3`, etc.).
     * If you want to have more meaningful IDs for your function, you can provide
     * them as the fourth argument, as an array of strings
     *
     * ```js
     * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
     *   elem.firstChild === document.getElementById('foo'); // true
     *   elem.lastChild === document.getElementById('bar'); // true
     * }, 2, ['foo', 'bar']);
     * ```
     *
     */

    var testStyles = ModernizrProto.testStyles = injectElementWithStyles;

    /*!
    {
      "name": "Hidden Scrollbar",
      "property": "hiddenscroll",
      "authors": ["Oleg Korsunsky"],
      "tags": ["overlay"],
      "notes": [{
        "name": "Overlay Scrollbar description",
        "href": "https://developer.apple.com/library/mac/releasenotes/MacOSX/WhatsNewInOSX/Articles/MacOSX10_7.html#//apple_ref/doc/uid/TP40010355-SW39"
      },{
        "name": "Video example of overlay scrollbars",
        "href": "https://gfycat.com/FoolishMeaslyAtlanticsharpnosepuffer"
      }]
    }
    !*/
    /* DOC
    Detects overlay scrollbars (when scrollbars on overflowed blocks are visible). This is found most commonly on mobile and OS X.
    */

    Modernizr.addTest('hiddenscroll', function () {
        return testStyles('#modernizr {width:100px;height:100px;overflow:scroll}', function (elem) {
            return elem.offsetWidth === elem.clientWidth;
        });
    });

    /*!
    {
      "name": "Touch Events",
      "property": "touchevents",
      "caniuse" : "touch",
      "tags": ["media", "attribute"],
      "notes": [{
        "name": "Touch Events spec",
        "href": "https://www.w3.org/TR/2013/WD-touch-events-20130124/"
      }],
      "warnings": [
        "Indicates if the browser supports the Touch Events spec, and does not necessarily reflect a touchscreen device"
      ],
      "knownBugs": [
        "False-positive on some configurations of Nokia N900",
        "False-positive on some BlackBerry 6.0 builds – https://github.com/Modernizr/Modernizr/issues/372#issuecomment-3112695"
      ]
    }
    !*/
    /* DOC
    Indicates if the browser supports the W3C Touch Events API.
    
    This *does not* necessarily reflect a touchscreen device:
    
    * Older touchscreen devices only emulate mouse events
    * Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
    * Some browsers & OS setups may enable touch APIs when no touchscreen is connected
    * Future browsers may implement other event models for touch interactions
    
    See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).
    
    It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](http://www.html5rocks.com/en/mobile/touchandmouse/).
    
    This test will also return `true` for Firefox 4 Multitouch support.
    */

    // Chrome (desktop) used to lie about its support on this, but that has since been rectified: http://crbug.com/36415
    Modernizr.addTest('touchevents', function () {
        var bool;
        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            bool = true;
        } else {
            // include the 'heartz' as a way to have a non matching MQ to help terminate the join
            // https://git.io/vznFH
            var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
            testStyles(query, function (node) {
                bool = node.offsetTop === 9;
            });
        }
        return bool;
    });

    /*!
    {
      "name": "details Element",
      "caniuse": "details",
      "property": "details",
      "tags": ["elem"],
      "builderAliases": ["elem_details"],
      "authors": ["@mathias"],
      "notes": [{
        "name": "Mathias' Original",
        "href": "https://mathiasbynens.be/notes/html5-details-jquery#comment-35"
      }]
    }
    !*/

    Modernizr.addTest('details', function () {
        var el = createElement('details');
        var diff;

        // return early if possible; thanks @aFarkas!
        if (!('open' in el)) {
            return false;
        }

        testStyles('#modernizr details{display:block}', function (node) {
            node.appendChild(el);
            el.innerHTML = '<summary>a</summary>b';
            diff = el.offsetHeight;
            el.open = true;
            diff = diff != el.offsetHeight;
        });


        return diff;
    });

    /*!
    {
      "name": "Form Validation",
      "property": "formvalidation",
      "tags": ["forms", "validation", "attribute"],
      "builderAliases": ["forms_validation"]
    }
    !*/
    /* DOC
    This implementation only tests support for interactive form validation.
    To check validation for a specific type or a specific other constraint,
    the test can be combined:
    
    - `Modernizr.inputtypes.number && Modernizr.formvalidation` (browser supports rangeOverflow, typeMismatch etc. for type=number)
    - `Modernizr.input.required && Modernizr.formvalidation` (browser supports valueMissing)
    */

    Modernizr.addTest('formvalidation', function () {
        var form = createElement('form');
        if (!('checkValidity' in form) || !('addEventListener' in form)) {
            return false;
        }
        if ('reportValidity' in form) {
            return true;
        }
        var invalidFired = false;
        var input;

        Modernizr.formvalidationapi = true;

        // Prevent form from being submitted
        form.addEventListener('submit', function (e) {
            // Old Presto based Opera does not validate form, if submit is prevented
            // although Opera Mini servers use newer Presto.
            if (!window.opera || window.operamini) {
                e.preventDefault();
            }
            e.stopPropagation();
        }, false);

        // Calling form.submit() doesn't trigger interactive validation,
        // use a submit button instead
        //older opera browsers need a name attribute
        form.innerHTML = '<input name="modTest" required="required" /><button></button>';

        testStyles('#modernizr form{position:absolute;top:-99999em}', function (node) {
            node.appendChild(form);

            input = form.getElementsByTagName('input')[0];

            // Record whether "invalid" event is fired
            input.addEventListener('invalid', function (e) {
                invalidFired = true;
                e.preventDefault();
                e.stopPropagation();
            }, false);

            //Opera does not fully support the validationMessage property
            Modernizr.formvalidationmessage = !!input.validationMessage;

            // Submit form by clicking submit button
            form.getElementsByTagName('button')[0].click();
        });

        return invalidFired;
    });


    /**
     * since we have a fairly large number of input tests that don't mutate the input
     * we create a single element that can be shared with all of those tests for a
     * minor perf boost
     *
     * @access private
     * @returns {HTMLInputElement}
     */
    var inputElem = createElement('input');

    /*!
    {
      "name": "Input attributes",
      "property": "input",
      "tags": ["forms"],
      "authors": ["Mike Taylor"],
      "notes": [{
        "name": "WHATWG spec",
        "href": "https://html.spec.whatwg.org/multipage/forms.html#input-type-attr-summary"
      }],
      "knownBugs": ["Some blackberry devices report false positive for input.multiple"]
    }
    !*/
    /* DOC
    Detects support for HTML5 `<input>` element attributes and exposes Boolean subproperties with the results:
    
    ```javascript
    Modernizr.input.autocomplete
    Modernizr.input.autofocus
    Modernizr.input.list
    Modernizr.input.max
    Modernizr.input.min
    Modernizr.input.multiple
    Modernizr.input.pattern
    Modernizr.input.placeholder
    Modernizr.input.required
    Modernizr.input.step
    ```
    */

    // Run through HTML5's new input attributes to see if the UA understands any.
    // Mike Taylr has created a comprehensive resource for testing these attributes
    //   when applied to all input types:
    //   miketaylr.com/code/input-type-attr.html

    // Only input placeholder is tested while textarea's placeholder is not.
    // Currently Safari 4 and Opera 11 have support only for the input placeholder
    // Both tests are available in feature-detects/forms-placeholder.js

    var inputattrs = 'autocomplete autofocus list placeholder max min multiple pattern required step'.split(' ');
    var attrs = {};

    Modernizr.input = (function (props) {
        for (var i = 0, len = props.length; i < len; i++) {
            attrs[props[i]] = !!(props[i] in inputElem);
        }
        if (attrs.list) {
            // safari false positive's on datalist: webk.it/74252
            // see also github.com/Modernizr/Modernizr/issues/146
            attrs.list = !!(createElement('datalist') && window.HTMLDataListElement);
        }
        return attrs;
    })(inputattrs);

    /*!
    {
      "name": "Form input types",
      "property": "inputtypes",
      "caniuse": "forms",
      "tags": ["forms"],
      "authors": ["Mike Taylor"],
      "polyfills": [
        "jquerytools",
        "webshims",
        "h5f",
        "webforms2",
        "nwxforms",
        "fdslider",
        "html5slider",
        "galleryhtml5forms",
        "jscolor",
        "html5formshim",
        "selectedoptionsjs",
        "formvalidationjs"
      ]
    }
    !*/
    /* DOC
    Detects support for HTML5 form input types and exposes Boolean subproperties with the results:
    
    ```javascript
    Modernizr.inputtypes.color
    Modernizr.inputtypes.date
    Modernizr.inputtypes.datetime
    Modernizr.inputtypes['datetime-local']
    Modernizr.inputtypes.email
    Modernizr.inputtypes.month
    Modernizr.inputtypes.number
    Modernizr.inputtypes.range
    Modernizr.inputtypes.search
    Modernizr.inputtypes.tel
    Modernizr.inputtypes.time
    Modernizr.inputtypes.url
    Modernizr.inputtypes.week
    ```
    */

    // Run through HTML5's new input types to see if the UA understands any.
    //   This is put behind the tests runloop because it doesn't return a
    //   true/false like all the other tests; instead, it returns an object
    //   containing each input type with its corresponding true/false value

    // Big thanks to @miketaylr for the html5 forms expertise. miketaylr.com/
    var inputtypes = 'search tel url email datetime date month week time datetime-local number range color'.split(' ');
    var inputs = {};

    Modernizr.inputtypes = (function (props) {
        var len = props.length;
        var smile = '1)';
        var inputElemType;
        var defaultView;
        var bool;

        for (var i = 0; i < len; i++) {

            inputElem.setAttribute('type', inputElemType = props[i]);
            bool = inputElem.type !== 'text' && 'style' in inputElem;

            // We first check to see if the type we give it sticks..
            // If the type does, we feed it a textual value, which shouldn't be valid.
            // If the value doesn't stick, we know there's input sanitization which infers a custom UI
            if (bool) {

                inputElem.value = smile;
                inputElem.style.cssText = 'position:absolute;visibility:hidden;';

                if (/^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined) {

                    docElement.appendChild(inputElem);
                    defaultView = document.defaultView;

                    // Safari 2-4 allows the smiley as a value, despite making a slider
                    bool = defaultView.getComputedStyle &&
                      defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
                      // Mobile android web browser has false positive, so must
                      // check the height to see if the widget is actually there.
                      (inputElem.offsetHeight !== 0);

                    docElement.removeChild(inputElem);

                } else if (/^(search|tel)$/.test(inputElemType)) {
                    // Spec doesn't define any special parsing or detectable UI
                    //   behaviors so we pass these through as true

                    // Interestingly, opera fails the earlier test, so it doesn't
                    //  even make it here.

                } else if (/^(url|email)$/.test(inputElemType)) {
                    // Real url and email support comes with prebaked validation.
                    bool = inputElem.checkValidity && inputElem.checkValidity() === false;

                } else {
                    // If the upgraded input compontent rejects the :) text, we got a winner
                    bool = inputElem.value != smile;
                }
            }

            inputs[props[i]] = !!bool;
        }
        return inputs;
    })(inputtypes);


    /**
     * roundedEquals takes two integers and checks if the first is within 1 of the second
     *
     * @access private
     * @function roundedEquals
     * @param {number} a
     * @param {number} b
     * @returns {boolean}
     */

    function roundedEquals(a, b) {
        return a - 1 === b || a === b || a + 1 === b;
    }

    ;


    /**
     * wrapper around getComputedStyle, to fix issues with Firefox returning null when
     * called inside of a hidden iframe
     *
     * @access private
     * @function computedStyle
     * @param {HTMLElement|SVGElement} - The element we want to find the computed styles of
     * @param {string|null} [pseudoSelector]- An optional pseudo element selector (e.g. :before), of null if none
     * @returns {CSSStyleDeclaration}
     */

    function computedStyle(elem, pseudo, prop) {
        var result;

        if ('getComputedStyle' in window) {
            result = getComputedStyle.call(window, elem, pseudo);
            var console = window.console;

            if (result !== null) {
                if (prop) {
                    result = result.getPropertyValue(prop);
                }
            } else {
                if (console) {
                    var method = console.error ? 'error' : 'log';
                    console[method].call(console, 'getComputedStyle returning null, its possible modernizr test results are inaccurate');
                }
            }
        } else {
            result = !pseudo && elem.currentStyle && elem.currentStyle[prop];
        }

        return result;
    }

    ;
    /*!
    {
      "name": "CSS vmax unit",
      "property": "cssvmaxunit",
      "caniuse": "viewport-units",
      "tags": ["css"],
      "builderAliases": ["css_vmaxunit"],
      "notes": [{
        "name": "Related Modernizr Issue",
        "href": "https://github.com/Modernizr/Modernizr/issues/572"
      },{
        "name": "JSFiddle Example",
        "href": "https://jsfiddle.net/glsee/JDsWQ/4/"
      }]
    }
    !*/

    testStyles('#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}', function (node) {
        var elem = node.childNodes[2];
        var scroller = node.childNodes[1];
        var fullSizeElem = node.childNodes[0];
        var scrollbarWidth = parseInt((scroller.offsetWidth - scroller.clientWidth) / 2, 10);

        var one_vw = fullSizeElem.clientWidth / 100;
        var one_vh = fullSizeElem.clientHeight / 100;
        var expectedWidth = parseInt(Math.max(one_vw, one_vh) * 50, 10);
        var compWidth = parseInt(computedStyle(elem, null, 'width'), 10);

        Modernizr.addTest('cssvmaxunit', roundedEquals(expectedWidth, compWidth) || roundedEquals(expectedWidth, compWidth - scrollbarWidth));
    }, 3);

    /*!
    {
      "name": "bdi Element",
      "property": "bdi",
      "notes": [{
        "name": "MDN Overview",
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/bdi"
      }]
    }
    !*/
    /* DOC
    Detect support for the bdi element, a way to have text that is isolated from its possibly bidirectional surroundings
    */

    Modernizr.addTest('bdi', function () {
        var div = createElement('div');
        var bdi = createElement('bdi');

        bdi.innerHTML = '&#1573;';
        div.appendChild(bdi);

        docElement.appendChild(div);

        var supports = computedStyle(bdi, null, 'direction') === 'rtl';

        docElement.removeChild(div);

        return supports;
    });


    /**
     * Object.prototype.toString can be used with every object and allows you to
     * get its class easily. Abstracting it off of an object prevents situations
     * where the toString property has been overridden
     *
     * @access private
     * @function toStringFn
     * @returns {function} An abstracted toString function
     */

    var toStringFn = ({}).toString;

    /*!
    {
      "name": "SVG clip paths",
      "property": "svgclippaths",
      "tags": ["svg"],
      "notes": [{
        "name": "Demo",
        "href": "http://srufaculty.sru.edu/david.dailey/svg/newstuff/clipPath4.svg"
      }]
    }
    !*/
    /* DOC
    Detects support for clip paths in SVG (only, not on HTML content).
    
    See [this discussion](https://github.com/Modernizr/Modernizr/issues/213) regarding applying SVG clip paths to HTML content.
    */

    Modernizr.addTest('svgclippaths', function () {
        return !!document.createElementNS &&
          /SVGClipPath/.test(toStringFn.call(document.createElementNS('http://www.w3.org/2000/svg', 'clipPath')));
    });

    /*!
    {
      "name": "Web Workers",
      "property": "webworkers",
      "caniuse" : "webworkers",
      "tags": ["performance", "workers"],
      "notes": [{
        "name": "W3C Reference",
        "href": "https://www.w3.org/TR/workers/"
      }, {
        "name": "HTML5 Rocks article",
        "href": "http://www.html5rocks.com/en/tutorials/workers/basics/"
      }, {
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/Web/Guide/Performance/Using_web_workers"
      }],
      "polyfills": ["fakeworker", "html5shims"]
    }
    !*/
    /* DOC
    Detects support for the basic `Worker` API from the Web Workers spec. Web Workers provide a simple means for web content to run scripts in background threads.
    */

    Modernizr.addTest('webworkers', 'Worker' in window);



    /**
     * contains checks to see if a string contains another string
     *
     * @access private
     * @function contains
     * @param {string} str - The string we want to check for substrings
     * @param {string} substr - The substring we want to search the first string for
     * @returns {boolean}
     */

    function contains(str, substr) {
        return !!~('' + str).indexOf(substr);
    }

    ;

    /**
     * nativeTestProps allows for us to use native feature detection functionality if available.
     * some prefixed form, or false, in the case of an unsupported rule
     *
     * @access private
     * @function nativeTestProps
     * @param {array} props - An array of property names
     * @param {string} value - A string representing the value we want to check via @supports
     * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
     */

    // Accepts a list of property names and a single value
    // Returns `undefined` if native detection not available
    function nativeTestProps(props, value) {
        var i = props.length;
        // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
        if ('CSS' in window && 'supports' in window.CSS) {
            // Try every prefixed variant of the property
            while (i--) {
                if (window.CSS.supports(domToCSS(props[i]), value)) {
                    return true;
                }
            }
            return false;
        }
            // Otherwise fall back to at-rule (for Opera 12.x)
        else if ('CSSSupportsRule' in window) {
            // Build a condition string for every prefixed variant
            var conditionText = [];
            while (i--) {
                conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
            }
            conditionText = conditionText.join(' or ');
            return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function (node) {
                return computedStyle(node, null, 'position') == 'absolute';
            });
        }
        return undefined;
    }
    ;

    /**
     * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
     *
     * @access private
     * @function fnBind
     * @param {function} fn - a function you want to change `this` reference to
     * @param {object} that - the `this` you want to call the function with
     * @returns {function} The wrapped version of the supplied function
     */

    function fnBind(fn, that) {
        return function () {
            return fn.apply(that, arguments);
        };
    }

    ;

    /**
     * testDOMProps is a generic DOM property test; if a browser supports
     *   a certain property, it won't return undefined for it.
     *
     * @access private
     * @function testDOMProps
     * @param {array.<string>} props - An array of properties to test for
     * @param {object} obj - An object or Element you want to use to test the parameters again
     * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
     * @returns {false|*} returns false if the prop is unsupported, otherwise the value that is supported
     */
    function testDOMProps(props, obj, elem) {
        var item;

        for (var i in props) {
            if (props[i] in obj) {

                // return the property name as a string
                if (elem === false) {
                    return props[i];
                }

                item = obj[props[i]];

                // let's bind a function
                if (is(item, 'function')) {
                    // bind to obj unless overriden
                    return fnBind(item, elem || obj);
                }

                // return the unbound function or obj or value
                return item;
            }
        }
        return false;
    }

    ;

    /**
     * Create our "modernizr" element that we do most feature tests on.
     *
     * @access private
     */

    var modElem = {
        elem: createElement('modernizr')
    };

    // Clean up this element
    Modernizr._q.push(function () {
        delete modElem.elem;
    });



    var mStyle = {
        style: modElem.elem.style
    };

    // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
    // the front of the queue.
    Modernizr._q.unshift(function () {
        delete mStyle.style;
    });



    // testProps is a generic CSS / DOM property test.

    // In testing support for a given CSS property, it's legit to test:
    //    `elem.style[styleName] !== undefined`
    // If the property is supported it will return an empty string,
    // if unsupported it will return undefined.

    // We'll take advantage of this quick test and skip setting a style
    // on our modernizr element, but instead just testing undefined vs
    // empty string.

    // Property names can be provided in either camelCase or kebab-case.

    function testProps(props, prefixed, value, skipValueTest) {
        skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

        // Try native detect first
        if (!is(value, 'undefined')) {
            var result = nativeTestProps(props, value);
            if (!is(result, 'undefined')) {
                return result;
            }
        }

        // Otherwise do it properly
        var afterInit, i, propsLength, prop, before;

        // If we don't have a style element, that means we're running async or after
        // the core tests, so we'll need to create our own elements to use

        // inside of an SVG element, in certain browsers, the `style` element is only
        // defined for valid tags. Therefore, if `modernizr` does not have one, we
        // fall back to a less used element and hope for the best.
        // for strict XHTML browsers the hardly used samp element is used
        var elems = ['modernizr', 'tspan', 'samp'];
        while (!mStyle.style && elems.length) {
            afterInit = true;
            mStyle.modElem = createElement(elems.shift());
            mStyle.style = mStyle.modElem.style;
        }

        // Delete the objects if we created them.
        function cleanElems() {
            if (afterInit) {
                delete mStyle.style;
                delete mStyle.modElem;
            }
        }

        propsLength = props.length;
        for (i = 0; i < propsLength; i++) {
            prop = props[i];
            before = mStyle.style[prop];

            if (contains(prop, '-')) {
                prop = cssToDOM(prop);
            }

            if (mStyle.style[prop] !== undefined) {

                // If value to test has been passed in, do a set-and-check test.
                // 0 (integer) is a valid property value, so check that `value` isn't
                // undefined, rather than just checking it's truthy.
                if (!skipValueTest && !is(value, 'undefined')) {

                    // Needs a try catch block because of old IE. This is slow, but will
                    // be avoided in most cases because `skipValueTest` will be used.
                    try {
                        mStyle.style[prop] = value;
                    } catch (e) { }

                    // If the property value has changed, we assume the value used is
                    // supported. If `value` is empty string, it'll fail here (because
                    // it hasn't changed), which matches how browsers have implemented
                    // CSS.supports()
                    if (mStyle.style[prop] != before) {
                        cleanElems();
                        return prefixed == 'pfx' ? prop : true;
                    }
                }
                    // Otherwise just return true, or the property name if this is a
                    // `prefixed()` call
                else {
                    cleanElems();
                    return prefixed == 'pfx' ? prop : true;
                }
            }
        }
        cleanElems();
        return false;
    }

    ;

    /**
     * testProp() investigates whether a given style property is recognized
     * Property names can be provided in either camelCase or kebab-case.
     *
     * @memberof Modernizr
     * @name Modernizr.testProp
     * @access public
     * @optionName Modernizr.testProp()
     * @optionProp testProp
     * @function testProp
     * @param {string} prop - Name of the CSS property to check
     * @param {string} [value] - Name of the CSS value to check
     * @param {boolean} [useValue] - Whether or not to check the value if @supports isn't supported
     * @returns {boolean}
     * @example
     *
     * Just like [testAllProps](#modernizr-testallprops), only it does not check any vendor prefixed
     * version of the string.
     *
     * Note that the property name must be provided in camelCase (e.g. boxSizing not box-sizing)
     *
     * ```js
     * Modernizr.testProp('pointerEvents')  // true
     * ```
     *
     * You can also provide a value as an optional second argument to check if a
     * specific value is supported
     *
     * ```js
     * Modernizr.testProp('pointerEvents', 'none') // true
     * Modernizr.testProp('pointerEvents', 'penguin') // false
     * ```
     */

    var testProp = ModernizrProto.testProp = function (prop, value, useValue) {
        return testProps([prop], undefined, value, useValue);
    };


    /**
     * testPropsAll tests a list of DOM properties we want to check against.
     * We specify literally ALL possible (known and/or likely) properties on
     * the element including the non-vendor prefixed one, for forward-
     * compatibility.
     *
     * @access private
     * @function testPropsAll
     * @param {string} prop - A string of the property to test for
     * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
     * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
     * @param {string} [value] - A string of a css value
     * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
     * @returns {false|string} returns the string version of the property, or false if it is unsupported
     */
    function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

        var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
          props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

        // did they call .prefixed('boxSizing') or are we just testing a prop?
        if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
            return testProps(props, prefixed, value, skipValueTest);

            // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
        } else {
            props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
            return testDOMProps(props, prefixed, elem);
        }
    }

    // Modernizr.testAllProps() investigates whether a given style property,
    // or any of its vendor-prefixed variants, is recognized
    //
    // Note that the property names must be provided in the camelCase variant.
    // Modernizr.testAllProps('boxSizing')
    ModernizrProto.testAllProps = testPropsAll;



    /**
     * prefixed returns the prefixed or nonprefixed property name variant of your input
     *
     * @memberof Modernizr
     * @name Modernizr.prefixed
     * @optionName Modernizr.prefixed()
     * @optionProp prefixed
     * @access public
     * @function prefixed
     * @param {string} prop - String name of the property to test for
     * @param {object} [obj] - An object to test for the prefixed properties on
     * @param {HTMLElement} [elem] - An element used to test specific properties against
     * @returns {string|false} The string representing the (possibly prefixed) valid
     * version of the property, or `false` when it is unsupported.
     * @example
     *
     * Modernizr.prefixed takes a string css value in the DOM style camelCase (as
     * opposed to the css style kebab-case) form and returns the (possibly prefixed)
     * version of that property that the browser actually supports.
     *
     * For example, in older Firefox...
     * ```js
     * prefixed('boxSizing')
     * ```
     * returns 'MozBoxSizing'
     *
     * In newer Firefox, as well as any other browser that support the unprefixed
     * version would simply return `boxSizing`. Any browser that does not support
     * the property at all, it will return `false`.
     *
     * By default, prefixed is checked against a DOM element. If you want to check
     * for a property on another object, just pass it as a second argument
     *
     * ```js
     * var rAF = prefixed('requestAnimationFrame', window);
     *
     * raf(function() {
     *  renderFunction();
     * })
     * ```
     *
     * Note that this will return _the actual function_ - not the name of the function.
     * If you need the actual name of the property, pass in `false` as a third argument
     *
     * ```js
     * var rAFProp = prefixed('requestAnimationFrame', window, false);
     *
     * rafProp === 'WebkitRequestAnimationFrame' // in older webkit
     * ```
     *
     * One common use case for prefixed is if you're trying to determine which transition
     * end event to bind to, you might do something like...
     * ```js
     * var transEndEventNames = {
     *     'WebkitTransition' : 'webkitTransitionEnd', * Saf 6, Android Browser
     *     'MozTransition'    : 'transitionend',       * only for FF < 15
     *     'transition'       : 'transitionend'        * IE10, Opera, Chrome, FF 15+, Saf 7+
     * };
     *
     * var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
     * ```
     *
     * If you want a similar lookup, but in kebab-case, you can use [prefixedCSS](#modernizr-prefixedcss).
     */

    var prefixed = ModernizrProto.prefixed = function (prop, obj, elem) {
        if (prop.indexOf('@') === 0) {
            return atRule(prop);
        }

        if (prop.indexOf('-') != -1) {
            // Convert kebab-case to camelCase
            prop = cssToDOM(prop);
        }
        if (!obj) {
            return testPropsAll(prop, 'pfx');
        } else {
            // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
            return testPropsAll(prop, obj, elem);
        }
    };



    /**
     * prefixedCSS is just like [prefixed](#modernizr-prefixed), but the returned values are in
     * kebab-case (e.g. `box-sizing`) rather than camelCase (boxSizing).
     *
     * @memberof Modernizr
     * @name Modernizr.prefixedCSS
     * @optionName Modernizr.prefixedCSS()
     * @optionProp prefixedCSS
     * @access public
     * @function prefixedCSS
     * @param {string} prop - String name of the property to test for
     * @returns {string|false} The string representing the (possibly prefixed)
     * valid version of the property, or `false` when it is unsupported.
     * @example
     *
     * `Modernizr.prefixedCSS` is like `Modernizr.prefixed`, but returns the result
     * in hyphenated form
     *
     * ```js
     * Modernizr.prefixedCSS('transition') // '-moz-transition' in old Firefox
     * ```
     *
     * Since it is only useful for CSS style properties, it can only be tested against
     * an HTMLElement.
     *
     * Properties can be passed as both the DOM style camelCase or CSS style kebab-case.
     */

    var prefixedCSS = ModernizrProto.prefixedCSS = function (prop) {
        var prefixedProp = prefixed(prop);
        return prefixedProp && domToCSS(prefixedProp);
    };

    /*!
    {
      "name": "Force Touch Events",
      "property": "forcetouch",
      "authors": ["Kraig Walker"],
      "notes": [{
        "name": "Responding to Force Touch Events from JavaScript",
        "href": "https://developer.apple.com/library/prerelease/mac/documentation/AppleApplications/Conceptual/SafariJSProgTopics/Articles/RespondingtoForceTouchEventsfromJavaScript.html"
      }]
    }
    !*/
    /* DOC
    Tests whether the browser supports the detection of Force Touch Events.
    Force Touch Events allow custom behaviours and interactions to take place based on the given pressure or change in pressure from a compatible trackpad.
    
    Force Touch events are available in OS X 10.11 and later on devices equipped with Force Touch trackpads.
    */

    Modernizr.addTest('forcetouch', function () {
        // github.com/Modernizr/Modernizr/issues/1613
        // Test if the browser supports the force touch event progression (see notes link)
        if (!hasEvent(prefixed('mouseforcewillbegin', window, false), window)) {
            return false;
        }

        // Test if the browser provides thresholds defining a "force touch" from a normal touch/click event
        return MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN && MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
    });

    /*!
    {
      "name": "Fullscreen API",
      "property": "fullscreen",
      "caniuse": "fullscreen",
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en/API/Fullscreen"
      }],
      "polyfills": ["screenfulljs"],
      "builderAliases": ["fullscreen_api"]
    }
    !*/
    /* DOC
    Detects support for the ability to make the current website take over the user's entire screen
    */

    // github.com/Modernizr/Modernizr/issues/739
    Modernizr.addTest('fullscreen', !!(prefixed('exitFullscreen', document, false) || prefixed('cancelFullScreen', document, false)));

    /*!
    {
      "name": "IndexedDB",
      "property": "indexeddb",
      "caniuse": "indexeddb",
      "tags": ["storage"],
      "polyfills": ["indexeddb"],
      "async": true
    }
    !*/
    /* DOC
    Detects support for the IndexedDB client-side storage API (final spec).
    */

    // Vendors had inconsistent prefixing with the experimental Indexed DB:
    // - Webkit's implementation is accessible through webkitIndexedDB
    // - Firefox shipped moz_indexedDB before FF4b9, but since then has been mozIndexedDB
    // For speed, we don't test the legacy (and beta-only) indexedDB

    Modernizr.addAsyncTest(function () {

        var indexeddb;

        try {
            // Firefox throws a Security Error when cookies are disabled
            indexeddb = prefixed('indexedDB', window);
        } catch (e) {
        }

        if (!!indexeddb) {
            var testDBName = 'modernizr-' + Math.random();
            var req = indexeddb.open(testDBName);

            req.onerror = function () {
                if (req.error && req.error.name === 'InvalidStateError') {
                    addTest('indexeddb', false);
                } else {
                    addTest('indexeddb', true);
                    detectDeleteDatabase(indexeddb, testDBName);
                }
            };

            req.onsuccess = function () {
                addTest('indexeddb', true);
                detectDeleteDatabase(indexeddb, testDBName);
            };
        } else {
            addTest('indexeddb', false);
        }
    });

    function detectDeleteDatabase(indexeddb, testDBName) {
        var deleteReq = indexeddb.deleteDatabase(testDBName);
        deleteReq.onsuccess = function () {
            addTest('indexeddb.deletedatabase', true);
        };
        deleteReq.onerror = function () {
            addTest('indexeddb.deletedatabase', false);
        };
    }

    ;
    /*!
    {
      "name": "IndexedDB Blob",
      "property": "indexeddbblob"
    }
    !*/
    /* DOC
    Detects if the browser can save File/Blob objects to IndexedDB
    */

    // Vendors had inconsistent prefixing with the experimental Indexed DB:
    // - Webkit's implementation is accessible through webkitIndexedDB
    // - Firefox shipped moz_indexedDB before FF4b9, but since then has been mozIndexedDB
    // For speed, we don't test the legacy (and beta-only) indexedDB

    Modernizr.addAsyncTest(function () {
        var indexeddb;
        var dbname = 'detect-blob-support';
        var supportsBlob = false;
        var openRequest;
        var db;
        var putRequest;

        try {
            indexeddb = prefixed('indexedDB', window);
        } catch (e) {
        }

        if (!(Modernizr.indexeddb && Modernizr.indexeddb.deletedatabase)) {
            return false;
        }

        // Calling `deleteDatabase` in a try…catch because some contexts (e.g. data URIs)
        // will throw a `SecurityError`
        try {
            indexeddb.deleteDatabase(dbname).onsuccess = function () {
                openRequest = indexeddb.open(dbname, 1);
                openRequest.onupgradeneeded = function () {
                    openRequest.result.createObjectStore('store');
                };
                openRequest.onsuccess = function () {
                    db = openRequest.result;
                    try {
                        putRequest = db.transaction('store', 'readwrite').objectStore('store').put(new Blob(), 'key');
                        putRequest.onsuccess = function () {
                            supportsBlob = true;
                        };
                        putRequest.onerror = function () {
                            supportsBlob = false;
                        };
                    }
                    catch (e) {
                        supportsBlob = false;
                    }
                    finally {
                        addTest('indexeddbblob', supportsBlob);
                        db.close();
                        indexeddb.deleteDatabase(dbname);
                    }
                };
            };
        }
        catch (e) {
            addTest('indexeddbblob', false);
        }
    });

    /*!
     {
     "name": "Internationalization API",
     "property": "intl",
     "notes": [{
     "name": "MDN documentation",
     "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl"
     },{
     "name": "ECMAScript spec",
     "href": "http://www.ecma-international.org/ecma-402/1.0/"
     }]
     }
     !*/
    /* DOC
    Detects support for the Internationalization API which allow easy formatting of number and dates and sorting string
    based on a locale
    */

    Modernizr.addTest('intl', !!prefixed('Intl', window));

    /*!
    {
      "name": "Page Visibility API",
      "property": "pagevisibility",
      "caniuse": "pagevisibility",
      "tags": ["performance"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/DOM/Using_the_Page_Visibility_API"
      },{
        "name": "W3C spec",
        "href": "https://www.w3.org/TR/2011/WD-page-visibility-20110602/"
      },{
        "name": "HTML5 Rocks tutorial",
        "href": "http://www.html5rocks.com/en/tutorials/pagevisibility/intro/"
      }],
      "polyfills": ["visibilityjs", "visiblyjs", "jquery-visibility"]
    }
    !*/
    /* DOC
    Detects support for the Page Visibility API, which can be used to disable unnecessary actions and otherwise improve user experience.
    */

    Modernizr.addTest('pagevisibility', !!prefixed('hidden', document, false));

    /*!
    {
      "name": "Navigation Timing API",
      "property": "performance",
      "caniuse": "nav-timing",
      "tags": ["performance"],
      "authors": ["Scott Murphy (@uxder)"],
      "notes": [{
        "name": "W3C Spec",
        "href": "https://www.w3.org/TR/navigation-timing/"
      },{
        "name": "HTML5 Rocks article",
        "href": "http://www.html5rocks.com/en/tutorials/webperformance/basics/"
      }],
      "polyfills": ["perfnow"]
    }
    !*/
    /* DOC
    Detects support for the Navigation Timing API, for measuring browser and connection performance.
    */

    Modernizr.addTest('performance', !!prefixed('performance', window));

    /*!
    {
      "name": "Pointer Lock API",
      "property": "pointerlock",
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/API/Pointer_Lock_API"
      }],
      "builderAliases": ["pointerlock_api"]
    }
    !*/
    /* DOC
    Detects support the pointer lock API which allows you to lock the mouse cursor to the browser window.
    */

    // https://developer.mozilla.org/en-US/docs/API/Pointer_Lock_API
    Modernizr.addTest('pointerlock', !!prefixed('exitPointerLock', document));

    /*!
    {
      "name": "Quota Storage Management API",
      "property": "quotamanagement",
      "tags": ["storage"],
      "builderAliases": ["quota_management_api"],
      "notes": [{
        "name": "W3C Spec",
        "href": "https://www.w3.org/TR/quota-api/"
      }]
    }
    !*/
    /* DOC
    Detects the ability to request a specific amount of space for filesystem access
    */

    Modernizr.addTest('quotamanagement', function () {
        var tempStorage = prefixed('temporaryStorage', navigator);
        var persStorage = prefixed('persistentStorage', navigator);

        return !!(tempStorage && persStorage);
    });

    /*!
    {
      "name": "requestAnimationFrame",
      "property": "requestanimationframe",
      "aliases": ["raf"],
      "caniuse": "requestanimationframe",
      "tags": ["animation"],
      "authors": ["Addy Osmani"],
      "notes": [{
        "name": "W3C spec",
        "href": "https://www.w3.org/TR/animation-timing/"
      }],
      "polyfills": ["raf"]
    }
    !*/
    /* DOC
    Detects support for the `window.requestAnimationFrame` API, for offloading animation repainting to the browser for optimized performance.
    */

    Modernizr.addTest('requestanimationframe', !!prefixed('requestAnimationFrame', window), { aliases: ['raf'] });

    /*!
    {
      "name": "getRandomValues",
      "property": "getrandomvalues",
      "caniuse": "window.crypto.getRandomValues",
      "tags": ["crypto"],
      "authors": ["komachi"],
      "notes": [{
        "name": "W3C Editor’s Draft",
        "href": "https://dvcs.w3.org/hg/webcrypto-api/raw-file/tip/spec/Overview.html#RandomSource-method-getRandomValues"
      }],
      "polyfills": [
        "polycrypt"
      ]
    }
    !*/
    /* DOC
    Detects support for the window.crypto.getRandomValues for generate cryptographically secure random numbers
    */

    // In Safari <=5.0 `window.crypto` exists (for some reason) but is `undefined`, so we have to check
    // it’s truthy before checking for existence of `getRandomValues`
    var crypto = prefixed('crypto', window);
    var supportsGetRandomValues;

    // Safari 6.0 supports crypto.getRandomValues, but does not return the array,
    // which is required by the spec, so we need to actually check.
    if (crypto && 'getRandomValues' in crypto && 'Uint32Array' in window) {
        var array = new Uint32Array(10);
        var values = crypto.getRandomValues(array);
        supportsGetRandomValues = values && is(values[0], 'number');
    }

    Modernizr.addTest('getrandomvalues', !!supportsGetRandomValues);

    /*!
    {
      "name": "CSS Background Blend Mode",
      "property": "backgroundblendmode",
      "caniuse": "css-backgroundblendmode",
      "tags": ["css"],
      "notes": [
        {
          "name": "CSS Blend Modes could be the next big thing in Web Design",
          "href": " https://medium.com/@bennettfeely/css-blend-modes-could-be-the-next-big-thing-in-web-design-6b51bf53743a"
        }, {
          "name": "Demo",
          "href": "http://bennettfeely.com/gradients/"
        }
      ]
    }
    !*/
    /* DOC
    Detects the ability for the browser to composite backgrounds using blending modes similar to ones found in Photoshop or Illustrator.
    */

    Modernizr.addTest('backgroundblendmode', prefixed('backgroundBlendMode', 'text'));

    /*!
    {
      "name": "CSS Object Fit",
      "caniuse": "object-fit",
      "property": "objectfit",
      "tags": ["css"],
      "builderAliases": ["css_objectfit"],
      "notes": [{
        "name": "Opera Article on Object Fit",
        "href": "https://dev.opera.com/articles/css3-object-fit-object-position/"
      }]
    }
    !*/

    Modernizr.addTest('objectfit', !!prefixed('objectFit'), { aliases: ['object-fit'] });

    /*!
    {
      "name": "Filesystem API",
      "property": "filesystem",
      "caniuse": "filesystem",
      "notes": [{
        "name": "W3 Draft",
        "href": "http://dev.w3.org/2009/dap/file-system/file-dir-sys.html"
      }],
      "authors": ["Eric Bidelman (@ebidel)"],
      "tags": ["file"],
      "builderAliases": ["file_filesystem"],
      "knownBugs": ["The API will be present in Chrome incognito, but will throw an exception. See crbug.com/93417"]
    }
    !*/

    Modernizr.addTest('filesystem', !!prefixed('requestFileSystem', window));

    /*!
    {
      "name": "Blob URLs",
      "property": "bloburls",
      "caniuse": "bloburls",
      "notes": [{
        "name": "W3C Working Draft",
        "href": "https://www.w3.org/TR/FileAPI/#creating-revoking"
      }],
      "tags": ["file", "url"],
      "authors": ["Ron Waldon (@jokeyrhyme)"]
    }
    !*/
    /* DOC
    Detects support for creating Blob URLs
    */

    var url = prefixed('URL', window, false);
    url = url && window[url];
    Modernizr.addTest('bloburls', url && 'revokeObjectURL' in url && 'createObjectURL' in url);

    /*!
    {
      "name": "Transferables Objects",
      "property": "transferables",
      "tags": ["performance", "workers"],
      "builderAliases": ["transferables"],
      "notes": [{
        "name": "HTML5 Rocks article",
        "href": "http://updates.html5rocks.com/2011/12/Transferable-Objects-Lightning-Fast"
      }],
      "async": true
    }
    !*/
    /* DOC
    Detects whether web workers can use `transferables` objects.
    */

    Modernizr.addAsyncTest(function () {
        var prerequisites = !!(Modernizr.blobconstructor &&
                               Modernizr.bloburls &&
                               Modernizr.webworkers &&
                               Modernizr.typedarrays);

        // Early exit
        if (!prerequisites) {
            return addTest('transferables', false);
        }

        // Proper test if prerequisites are met
        try {
            var buffer,
              scriptText = 'var hello = "world"',
              blob = new Blob([scriptText], { type: 'text/javascript' }),
              url = URL.createObjectURL(blob),
              worker = new Worker(url),
              timeout;

            // Just in case...
            worker.onerror = fail;
            timeout = setTimeout(fail, 200);

            // Building an minimal array buffer to send to the worker
            buffer = new ArrayBuffer(1);

            // Sending the buffer to the worker
            worker.postMessage(buffer, [buffer]);

            // If length of buffer is now 0, transferables are working
            addTest('transferables', buffer.byteLength === 0);
            cleanup();
        } catch (e) {
            fail();
        }

        function fail() {
            addTest('transferables', false);
            cleanup();
        }

        function cleanup() {
            if (url) {
                URL.revokeObjectURL(url);
            }
            if (worker) {
                worker.terminate();
            }
            if (timeout) {
                clearTimeout(timeout);
            }
        }
    });


    /**
     * testAllProps determines whether a given CSS property is supported in the browser
     *
     * @memberof Modernizr
     * @name Modernizr.testAllProps
     * @optionName Modernizr.testAllProps()
     * @optionProp testAllProps
     * @access public
     * @function testAllProps
     * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
     * @param {string} [value] - String of the value to test
     * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
     * @example
     *
     * testAllProps determines whether a given CSS property, in some prefixed form,
     * is supported by the browser.
     *
     * ```js
     * testAllProps('boxSizing')  // true
     * ```
     *
     * It can optionally be given a CSS value in string form to test if a property
     * value is valid
     *
     * ```js
     * testAllProps('display', 'block') // true
     * testAllProps('display', 'penguin') // false
     * ```
     *
     * A boolean can be passed as a third parameter to skip the value check when
     * native detection (@supports) isn't available.
     *
     * ```js
     * testAllProps('shapeOutside', 'content-box', true);
     * ```
     */

    function testAllProps(prop, value, skipValueTest) {
        return testPropsAll(prop, undefined, undefined, value, skipValueTest);
    }
    ModernizrProto.testAllProps = testAllProps;

    /*!
    {
      "name": "Font Ligatures",
      "property": "ligatures",
      "caniuse": "font-feature",
      "notes": [{
        "name": "Cross-browser Web Fonts",
        "href": "http://www.sitepoint.com/cross-browser-web-fonts-part-3/"
      }]
    }
    !*/
    /* DOC
    Detects support for OpenType ligatures
    */

    Modernizr.addTest('ligatures', testAllProps('fontFeatureSettings', '"liga" 1'));

    /*!
    {
      "name": "Appearance",
      "property": "appearance",
      "caniuse": "css-appearance",
      "tags": ["css"],
      "notes": [{
        "name": "MDN documentation",
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-appearance"
      },{
        "name": "CSS-Tricks CSS Almanac: appearance",
        "href": "https://css-tricks.com/almanac/properties/a/appearance/"
      }]
    }
    !*/
    /* DOC
    Detects support for the `appearance` css property, which is used to make an
    element inherit the style of a standard user interface element. It can also be
    used to remove the default styles of an element, such as input and buttons.
    */

    Modernizr.addTest('appearance', testAllProps('appearance'));

    /*!
    {
      "name": "CSS Background Clip Text",
      "property": "backgroundcliptext",
      "authors": ["ausi"],
      "tags": ["css"],
      "notes": [
        {
          "name": "CSS Tricks Article",
          "href": "https://css-tricks.com/image-under-text/"
        },
        {
          "name": "MDN Docs",
          "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip"
        },
        {
          "name": "Related Github Issue",
          "href": "https://github.com/Modernizr/Modernizr/issues/199"
        }
      ]
    }
    !*/
    /* DOC
    Detects the ability to control specifies whether or not an element's background
    extends beyond its border in CSS
    */

    Modernizr.addTest('backgroundcliptext', function () {
        return testAllProps('backgroundClip', 'text');
    });

    /*!
    {
      "name": "Border Image",
      "property": "borderimage",
      "caniuse": "border-image",
      "polyfills": ["css3pie"],
       "knownBugs": ["Android < 2.0 is true, but has a broken implementation"],
      "tags": ["css"]
    }
    !*/

    Modernizr.addTest('borderimage', testAllProps('borderImage', 'url() 1', true));

    /*!
    {
      "name": "CSS Filters",
      "property": "cssfilters",
      "caniuse": "css-filters",
      "polyfills": ["polyfilter"],
      "tags": ["css"],
      "builderAliases": ["css_filters"],
      "notes": [{
        "name": "MDN article on CSS filters",
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/filter"
      }]
    }
    !*/

    Modernizr.addTest('cssfilters', function () {
        if (Modernizr.supports) {
            return testAllProps('filter', 'blur(2px)');
        } else {
            var el = createElement('a');
            el.style.cssText = prefixes.join('filter:blur(2px); ');
            // https://github.com/Modernizr/Modernizr/issues/615
            // documentMode is needed for false positives in oldIE, please see issue above
            return !!el.style.length && ((document.documentMode === undefined || document.documentMode > 9));
        }
    });


    /*!
    {
      "name": "Flexbox (tweener)",
      "property": "flexboxtweener",
      "tags": ["css"],
      "polyfills": ["flexie"],
      "notes": [{
        "name": "The _inbetween_ flexbox",
        "href": "https://www.w3.org/TR/2011/WD-css3-flexbox-20111129/"
      }],
      "warnings": ["This represents an old syntax, not the latest standard syntax."]
    }
    !*/

    Modernizr.addTest('flexboxtweener', testAllProps('flexAlign', 'end', true));

    /*!
    {
      "name": "Flex Line Wrapping",
      "property": "flexwrap",
      "tags": ["css", "flexbox"],
      "notes": [{
        "name": "W3C Flexible Box Layout spec",
        "href": "http://dev.w3.org/csswg/css3-flexbox"
      }],
      "warnings": [
        "Does not imply a modern implementation – see documentation."
      ]
    }
    !*/
    /* DOC
    Detects support for the `flex-wrap` CSS property, part of Flexbox, which isn’t present in all Flexbox implementations (notably Firefox).
    
    This featured in both the 'tweener' syntax (implemented by IE10) and the 'modern' syntax (implemented by others). This detect will return `true` for either of these implementations, as long as the `flex-wrap` property is supported. So to ensure the modern syntax is supported, use together with `Modernizr.flexbox`:
    
    ```javascript
    if (Modernizr.flexbox && Modernizr.flexwrap) {
      // Modern Flexbox with `flex-wrap` supported
    }
    else {
      // Either old Flexbox syntax, or `flex-wrap` not supported
    }
    ```
    */

    Modernizr.addTest('flexwrap', testAllProps('flexWrap', 'wrap', true));

    /*!
    {
      "name": "CSS Mask",
      "caniuse": "css-masks",
      "property": "cssmask",
      "tags": ["css"],
      "builderAliases": ["css_mask"],
      "notes": [
        {
          "name": "Webkit blog on CSS Masks",
          "href": "https://webkit.org/blog/181/css-masks/"
        },
        {
          "name": "Safari Docs",
          "href": "https://developer.apple.com/library/safari/#documentation/InternetWeb/Conceptual/SafariVisualEffectsProgGuide/Masks/Masks.html"
        },
        {
          "name": "CSS SVG mask",
          "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/mask"
        },
        {
          "name": "Combine with clippaths for awesomeness",
          "href": "https://generic.cx/for/webkit/test.html"
        }
      ]
    }
    !*/

    Modernizr.addTest('cssmask', testAllProps('maskRepeat', 'repeat-x', true));

    /*!
    {
      "name": "CSS Reflections",
      "caniuse": "css-reflections",
      "property": "cssreflections",
      "tags": ["css"]
    }
    !*/

    Modernizr.addTest('cssreflections', testAllProps('boxReflect', 'above', true));

    /*!
    {
      "name": "CSS UI Resize",
      "property": "cssresize",
      "caniuse": "css-resize",
      "tags": ["css"],
      "builderAliases": ["css_resize"],
      "notes": [{
        "name": "W3C Specification",
        "href": "https://www.w3.org/TR/css3-ui/#resize"
      },{
        "name": "MDN Docs",
        "href": "https://developer.mozilla.org/en/CSS/resize"
      }]
    }
    !*/
    /* DOC
    Test for CSS 3 UI "resize" property
    */

    Modernizr.addTest('cssresize', testAllProps('resize', 'both', true));

    /*!
    {
      "name": "CSS Shapes",
      "property": "shapes",
      "tags": ["css"],
      "notes": [{
        "name": "CSS Shapes W3C specification",
        "href": "https://www.w3.org/TR/css-shapes"
      },{
        "name": "Examples from Adobe",
        "href": "http://webplatform.adobe.com/shapes/"
      }, {
        "name": "Samples showcasing uses of Shapes",
        "href": "http://codepen.io/collection/qFesk"
      }]
    }
    !*/

    Modernizr.addTest('shapes', testAllProps('shapeOutside', 'content-box', true));

    /*!
    {
      "name": "CSS text-align-last",
      "property": "textalignlast",
      "tags": ["css"],
      "knownBugs": ["IE does not support the 'start' or 'end' values."],
      "notes": [{
          "name": "Quicksmode",
          "href": "http://www.quirksmode.org/css/text/textalignlast.html"
        },{
          "name": "MDN",
          "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-align-last"
        }]
    }
    !*/

    Modernizr.addTest('textalignlast', testAllProps('textAlignLast'));


    // Run each test
    testRunner();

    // Remove the "no-js" class if it exists
    setClasses(classes);

    delete ModernizrProto.addTest;
    delete ModernizrProto.addAsyncTest;

    // Run the things that are supposed to run after the tests
    for (var i = 0; i < Modernizr._q.length; i++) {
        Modernizr._q[i]();
    }

    // Leak Modernizr namespace
    window.Modernizr = Modernizr;


    ;

})(window, document);